import React, { useState, useRef, useEffect } from "react";
import { TextField, Grid, InputLabel, FormControl, Select, MenuItem, FormControlLabel, Checkbox, TextareaAutosize, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import "bootstrap/dist/css/bootstrap.min.css";
import CloseIcon from '@mui/icons-material/Close';
import AccountMasterHelp from "../../../Helper/AccountMasterHelp";
import SystemmasterHelp from "../../../Helper/SystemmasterHelp"
import axios from "axios";
import { useNavigate, useLocation, Await } from "react-router-dom";
import ActionButtonGroup from "../../../Common/CommonButtons/ActionButtonGroup";
import NavigationButtons from "../../../Common/CommonButtons/NavigationButtons";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useRecordLocking } from '../../../hooks/useRecordLocking';
import "./HaladsaleBill.css"
import AddButton from "../../../Common/Buttons/AddButton";
import EditButton from "../../../Common/Buttons/EditButton";
import DeleteButton from "../../../Common/Buttons/DeleteButton";
import OpenButton from "../../../Common/Buttons/OpenButton";
import UserAuditInfo from "../../../Common/UserAuditInfo/UserAuditInfo";
import SaveUpdateSpinner from "../../../Common/Spinners/SaveUpdateSpinner";
import Swal from "sweetalert2";
import EwayBillGeneration from "../../../Common/EwaybillNEInvoice/Ewaybill/EwayBillGeneration";
import EInvoiceGeneration from "../../../Common/EwaybillNEInvoice/EInvoiceGenerationProcess/EInvoiceGeneration";
import DetailAddButtom from "../../../Common/Buttons/DetailAddButton";
import DetailCloseButton from "../../../Common/Buttons/DetailCloseButton";
import DetailUpdateButton from "../../../Common/Buttons/DetailUpdateButton";
import { OutwordPostDateRecordLock } from "../../../Common/PostDateLock/PostDateRangeCheck"
import { validateDocumentDate } from "../../../Common/ValidateDateRange/ValidateDateRange"
import { formatReadableAmount } from "../../../Common/FormatFunctions/FormatAmount";
import AwakEntryhelp from "../../../Helper/PattiAwakEntryHelp";
import GulSaleBillReport from "./HaladSaleBillReport";
import GulSaleBillDetailReport from "./HaladSaleBillDetailReport";
import GulSaleBillBatchReport from "./HaladSaleBillBatchPrinting";

//Global Variables
var newsalebillId = "";
var partyName = "";
var AwakNo = "";
var Awakid = "";
var millName = "";
var millCode = "";
var unitName = "";
var unitCode = "";
var brokerName = "";
var brokerCode = "";
var itemName = "";
var item_Code = "";
var brandName = "";
var brandCode = "";
var billToName = "";
var billToCode = "";
var millgstno = "";
var FarmerCode = "";
var fc = "";
var ic = "";
var PattiNo = "";
var PattiId = "";
var isAwaknoDisabled = false;
// var AwakNo = "";
var awakdetailId = "";
var selectedfilter = "";


// Common style for all table headers
const headerCellStyle = {
    fontWeight: "bold",
    backgroundColor: "#3f51b5",
    color: "white",
    padding: "6px",
    textAlign: "center",
    "&:hover": {
        backgroundColor: "#303f9f",
        cursor: "pointer",
    },
};

//API URL
const API_URL = process.env.REACT_APP_API;

const HaladSaleBill = () => {

    //GET Values from session
    const companyCode = sessionStorage.getItem("Company_Code");
    const Year_Code = sessionStorage.getItem("Year_Code");
    const Outword_Date = sessionStorage.getItem("Outword_Date")
    const Post_Date = sessionStorage.getItem("Post_Date")
    const username = sessionStorage.getItem("username");
    const TCSApplicable = sessionStorage.getItem("TCSApplicable");
    const User_Id = sessionStorage.getItem("User_ID");

    const location = useLocation();
    selectedfilter = location.state?.selectedfilter;
    const searchParams = new URLSearchParams(location.search);
    const navigatedRecord = searchParams.get('navigatedRecord');
    const navigatedTranType = searchParams.get('navigatedTranType');
    const permissions = location.state?.permissionsData;

    const [TranType, setTranType] = useState(selectedfilter);


    //State Management
    const [users, setUsers] = useState([]);
    const [selectedFetchedDetail, setSelectedFetchedDetail] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [popupMode, setPopupMode] = useState("add");
    const [selectedUser, setSelectedUser] = useState({});
    const [deleteMode, setDeleteMode] = useState(false);
    const [itemCode, setItemCode] = useState("");
    const [item_Name, setItemName] = useState("");
    const [line_code, setLineCode] = useState("");
    const [line_name, setLineName] = useState("");
    const [LineAccoid, setLineAccoid] = useState("");
    const [itemCodeAccoid, setItemCodeAccoid] = useState("");
    const [formDataDetail, setFormDataDetail] = useState({
        wtpr: 0.0,
        Quantity: 0.00 || "",
        QuantitytoShow: 0.00 || "",
        Net_weight: 0.00 || "",
        isNetWeightManuallyChanged: false,
        Dekrekh: 0.0 || "",
        Market_Cess: 0.0 || "",
        Dekrekh_Rate: 0.0 || "",
        Market_Rate: 0.0 || "",
        Hamali: 0.0 || "",
        Tolai: 0.0 || "",
        leavy: 0.0 || "",
        Leavy_Rate: 0.0 || "",
        Rate: 0.0 || "",
        container: 0.0 || "",
        containerAmt: 0.0 || "",
        isContainerManuallyChanged: false,
        Amount: 0.0 || "",
        Awak_No: 0 || "",
        Awak_Id: 0 || "",
        Farmer_Code: 0 || "",
        fc: 0 || "",
        Patti_No: 0,
        Patti_Id: 0,
        additionNetWt: "",
        GrossWt: 0.00 || "",
        tolaidarName: "",
        BagSut: 0.00,
        ExtraSut: 0.00,
        awakdetailId: 0,
        detail_id: 1,
        hamalical: 0.00,
        Tolaical: 0.00,
        awkid: 0,
        KattaPatti: 0,
        SrNo: 1,
    });

    //Head Section State Managements
    const [addOneButtonEnabled, setAddOneButtonEnabled] = useState(false);
    const [saveButtonEnabled, setSaveButtonEnabled] = useState(true);
    const [cancelButtonEnabled, setCancelButtonEnabled] = useState(true);
    const [editButtonEnabled, setEditButtonEnabled] = useState(false);
    const [deleteButtonEnabled, setDeleteButtonEnabled] = useState(false);
    const [backButtonEnabled, setBackButtonEnabled] = useState(true);
    const [isEditMode, setIsEditMode] = useState(false);
    const [highlightedButton, setHighlightedButton] = useState(null);
    const [cancelButtonClicked, setCancelButtonClicked] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [lastTenderDetails, setLastTenderDetails] = useState([]);
    const [lastTenderData, setLastTenderData] = useState({});
    const [formErrors, setFormErrors] = useState({});
    const [isChecked, setIsChecked] = useState(false);
    const [gstNo, setGstNo] = useState("");
    const [isHandleChange, setIsHandleChange] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isOpenEInvoice, setIsOpenEInvoice] = useState(false);
    const [isOpenEwayBill, setIsOpenEwayBill] = useState(false);
    const [showAdditionPopup, setShowAdditionPopup] = useState(false);
    const [additionRows, setAdditionRows] = useState([]);

    const [marketCessApplicable, setMarketCessApplicable] = useState('N'); // default 'N'

    const [srNoMap, setSrNoMap] = useState({});
    const [srNoCounter, setSrNoCounter] = useState(0);
    const [editSrNoCounter, setEditSrNoCounter] = useState(0);

    const [BrokerCodeManuallySet, setBrokerCodeManuallySet] = useState(false);
    const [shipToManuallySet, setShipToManuallySet] = useState(false);
    const [bill_To_Name, setBillToName] = useState('')
    const [ship_To_Name, setShipToName] = useState('')

    const [isProformafetched, setisProformafetched] = useState(false);
    const [Awakcode, setAwakCode] = useState("");
    const [AwakId, setAwakId] = useState("");
    const [checkRateperData, setCheckRateperData] = useState(null);
    const [netWeightExpression, setNetWeightExpression] = useState('');
    const [originalNetWeight, setOriginalNetWeight] = useState(0);
    const [isCalculating, setIsCalculating] = useState(false);

    const selectedRecord = location.state?.selectedRecord;
    const navigate = useNavigate();
    const inputRef = useRef(null)
    const cellRefs = useRef([]);
    const netWeightRef = useRef(null);
    const quantityRef = useRef(null);


    //SET Focus to the ADD Buttons.
    const addButtonRef = useRef(null);
    const firstInputRef = useRef(null);
    const setFocusToFirstField = () => {
        if (firstInputRef.current) {
            firstInputRef.current.focus();
        }
    };

    //Initial Formdata
    const initialFormData = {
        doc_no: "",
        doc_date: new Date().toISOString().split("T")[0],
        Customer_Code: "",
        Broker_code: "",
        Sauda_Type: 'T' || "",
        Commission: 0.00,
        SubTotal: 0.00,
        Commission_Rate: 0.00,
        Expense_Subtotal: 0.00,
        Net_weight: 0.00,
        Bill_Amount: 0.00,
        Due_days: 1,
        Net_quantity: 0.00,
        Company_Code: companyCode,
        Year_Code: Year_Code,
        Created_By: "",
        Modified_By: "",
        cc: 0,
        Bc: 0,
        Leavy: 0.00,
        Container: 0.00,
        MarketCess: 0.00,
        DekhRekh: 0.00,
        salebillId: null,
        Narration: "",
        RoundOff: 0.0,
        TDS_Amt: 0.0,
        TDS_Rate: 0.0,
        Truck_No: "",
        TolaiAmt: 0.00,
        HamaliAmt: 0.00,
        SaudaDate: new Date().toISOString().split("T")[0],
        Ac_Code: "",
        ac: "",
        Tran_Type: TranType ? TranType : "GS",
    };

    //ALL Help Section State managements
    const [formData, setFormData] = useState(initialFormData);

    useEffect(() => {
        if (isHandleChange) {
            handleCancel();
            setIsHandleChange(false);
        }
        // document.getElementById("doc_no").focus();
    }, [TranType]);

    // const handleChange = (event) => {
    //     const { name, value } = event.target;
    //     if (name === "System_Type") {
    //         setSystemType(value);
    //         setIsHandleChange(true);
    //     } else {
    //         setFormData((prevState) => ({
    //             ...prevState,
    //             [name]: value,
    //         }));
    //     }
    // };

    const [CustomerCode, setCustomerCode] = useState("");
    const [broker, setBroker] = useState("");
    const [AcCode, setAcCode] = useState("");
    const [AcName, setAcName] = useState("");
    const [Acaccoid, setAcaccoid] = useState("");



    // Manage the lock-unlock record at the same time multiple users edit the same record.
    const { isRecordLockedByUser, lockRecord, unlockRecord } = useRecordLocking(formData.doc_no, undefined, companyCode, Year_Code, "sugar_sale");

    //Validation Input feilds
    const validateNumericInput = (e) => {
        e.target.value = e.target.value.replace(/[^0-9.-]/g, '');
    };

    const formatTruckNumber = (value) => {
        const cleanedValue = value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
        return cleanedValue.length <= 10 ? cleanedValue : cleanedValue.substring(0, 10);
    };



    const checkRate = async (systemid) => {
        debugger
        try {
            const res = await axios.get(
                `${API_URL}/get-SystemMaster-SelectedRecord`,
                {
                    params: {
                        selected_code: systemid,
                        Company_Code: companyCode,
                        System_Type: "I",
                    },
                }
            );

            const rateData = res.data.Selected_SystemMaster_data;

            if (rateData) {
                const minRate = parseFloat(rateData.minRate);
                const maxRate = parseFloat(rateData.maxRate);
                const minWeight = parseFloat(rateData.minWeight);
                const maxWeight = parseFloat(rateData.maxWeight);

                return { minRate, maxRate, minWeight, maxWeight };
            }
        } catch (err) {
            console.error("Error fetching system rate range:", err);
        }

        return null;
    };
    //Handle Records OnChange Method
    const handleChange = (event) => {
        const { name, value } = event.target;

        let updatedValue = value;

        // Format Truck Number
        if (name === "Truck_No") {
            updatedValue = formatTruckNumber(value);
        }

        // Handle Tran Type separately
        if (name === "Tran_Type") {
            setTranType(updatedValue);
            setIsHandleChange(true);
        }

        // Update formData for all fields
        setFormData((prevData) => ({
            ...prevData,
            [name]: updatedValue,
        }));
    };




    // const handleKeyDownCalculations = async (event) => {
    //     if (event.key === "Tab") {
    //         const { name, value } = event.target;

    //         //Parse value safely
    //         const newValue =
    //             name === "" || name === ""
    //                 ? parseFloat(value) || 0
    //                 : parseFloat(value) || value;

    //         //Update detail object
    //         let updatedDetail = { ...formDataDetail, [name]: newValue };

    //         //Prepare rates
    //         const Market_Rate = !isNaN(parseFloat(updatedDetail.Market_Rate))
    //             ? parseFloat(updatedDetail.Market_Rate)
    //             : parseFloat(selectedFetchedDetail?.Market_Cess) || 0;

    //         const Dekrekh_Rate = !isNaN(parseFloat(updatedDetail.Dekrekh_Rate))
    //             ? parseFloat(updatedDetail.Dekrekh_Rate)
    //             : parseFloat(selectedFetchedDetail?.Dekrekh) || 0;

    //         const hamali =
    //             !isNaN(parseFloat(updatedDetail.Hamali))
    //                 ? parseFloat(updatedDetail.Hamali)
    //                 // : parseFloat(selectedFetchedDetail?.Hamali_rate) || 0;
    //                 : getEffectiveHamaliRate(selectedFetchedDetail);

    //         const tolai =
    //             !isNaN(parseFloat(updatedDetail.Tolai))
    //                 ? parseFloat(updatedDetail.Tolai)
    //                 // : parseFloat(selectedFetchedDetail?.Tolai_rate) || 0;
    //                 : getEffectiveTolaiRate(selectedFetchedDetail);

    //         const Leavy_Rate =
    //             !isNaN(parseFloat(updatedDetail.Leavy_Rate))
    //                 ? parseFloat(updatedDetail.Leavy_Rate)
    //                 : parseFloat(selectedFetchedDetail?.Levi_rate) || 0;

    //         const containerValue =
    //             !isNaN(parseFloat(updatedDetail.container))
    //                 ? parseFloat(updatedDetail.container)
    //                 : parseFloat(selectedFetchedDetail?.Container) || 0;

    //         const { Quantity, Rate, Net_weight } = updatedDetail;

    //         //Call calculateDetails with container flags
    //         const {
    //             Amount,
    //             MarketCess,
    //             DekhRekh,
    //             Hamali,
    //             Tolai,
    //             Hamali_Rate,
    //             Tolai_Rate,
    //             Leavy,
    //             containerAmt,
    //         } = await calculateDetails(
    //             Quantity,
    //             Rate,
    //             Net_weight,
    //             Market_Rate,
    //             Dekrekh_Rate,
    //             hamali,
    //             tolai,
    //             Leavy_Rate,
    //             formDataDetail.isNetWeightManuallyChanged,
    //             formDataDetail.Net_weight,
    //             formDataDetail.isContainerManuallyChanged,
    //             updatedDetail.containerAmt,
    //             containerValue
    //         );

    //         //Update state with manual flags for NetWt & container
    //         setFormDataDetail((prev) => {
    //             let isNetWeightManuallyChanged = prev.isNetWeightManuallyChanged;
    //             let isContainerManuallyChanged = prev.isContainerManuallyChanged;

    //             // If user edits Net_weight → mark manual
    //             if (name === "Net_weight") isNetWeightManuallyChanged = true;

    //             // Reset Net_weight manual flag if Quantity or wtpr changes
    //             if (name === "Quantity" || name === "wtpr") isNetWeightManuallyChanged = false;

    //             // If user edits container → mark manual
    //             if (name === "containerAmt") {
    //                 isContainerManuallyChanged = true;
    //             }

    //             // If user edits container OR Quantity → auto recalc
    //             if (name === "container" || name === "Quantity") {
    //                 isContainerManuallyChanged = false;
    //             }
    //             return {
    //                 ...prev,
    //                 [name]: newValue,
    //                 Amount,
    //                 Net_weight: updatedDetail.Net_weight,
    //                 Market_Cess: MarketCess,
    //                 Dekrekh: DekhRekh,
    //                 Hamali,
    //                 Tolai,
    //                 hamalical: Hamali_Rate,
    //                 Tolaical: Tolai_Rate,
    //                 leavy: Leavy,
    //                 container: containerValue,
    //                 containerAmt,
    //                 Market_Rate,
    //                 Dekrekh_Rate,
    //                 Leavy_Rate,
    //                 isNetWeightManuallyChanged,
    //                 isContainerManuallyChanged,
    //             };
    //         });

    //         //Update dependent values in head form (unchanged)
    //         const updatedFormData = await calculateDependentValues(name, value, formData);
    //         setFormData((prev) => ({
    //             ...prev,
    //             ...updatedFormData,
    //         }));
    //     }
    // };

    // Fields that, when tabbed/changed, should force a fresh pull of 
    // Hamali/Tolai/Leavy rates from the source Awak record (selectedFetchedDetail)
    const RATE_REFRESH_FIELDS = ["Quantity", "Net_weight", "GrossWt", "ExtraSut", "BagSut", "wtpr"];

    const handleKeyDownCalculations = async (event) => {
        if (event.key === "Tab") {
            const { name, value } = event.target;

            //Parse value safely
            const newValue =
                name === "" || name === ""
                    ? parseFloat(value) || 0
                    : parseFloat(value) || value;

            //Update detail object
            let updatedDetail = { ...formDataDetail, [name]: newValue };

            //Prepare rates
            const Market_Rate = !isNaN(parseFloat(updatedDetail.Market_Rate))
                ? parseFloat(updatedDetail.Market_Rate)
                : parseFloat(selectedFetchedDetail?.Market_Cess) || 0;

            const Dekrekh_Rate = !isNaN(parseFloat(updatedDetail.Dekrekh_Rate))
                ? parseFloat(updatedDetail.Dekrekh_Rate)
                : parseFloat(selectedFetchedDetail?.Dekrekh) || 0;

            //  Force refresh Hamali/Tolai/Leavy_Rate from source whenever a
            //  weight/quantity-basis field changes, instead of trusting the
            //  already-numeric value sitting in updatedDetail (which is why
            //  edit mode was getting stuck on stale rates)
            const shouldRefreshRates = RATE_REFRESH_FIELDS.includes(name) && !!selectedFetchedDetail;

            const hamali = shouldRefreshRates
                ? getEffectiveHamaliRate(selectedFetchedDetail)
                : (!isNaN(parseFloat(updatedDetail.Hamali))
                    ? parseFloat(updatedDetail.Hamali)
                    : getEffectiveHamaliRate(selectedFetchedDetail));

            const tolai = shouldRefreshRates
                ? getEffectiveTolaiRate(selectedFetchedDetail)
                : (!isNaN(parseFloat(updatedDetail.Tolai))
                    ? parseFloat(updatedDetail.Tolai)
                    : getEffectiveTolaiRate(selectedFetchedDetail));

            const Leavy_Rate = shouldRefreshRates
                ? (parseFloat(selectedFetchedDetail?.Levi_rate) || 0)
                : (!isNaN(parseFloat(updatedDetail.Leavy_Rate))
                    ? parseFloat(updatedDetail.Leavy_Rate)
                    : (parseFloat(selectedFetchedDetail?.Levi_rate) || 0));

            const containerValue =
                !isNaN(parseFloat(updatedDetail.container))
                    ? parseFloat(updatedDetail.container)
                    : parseFloat(selectedFetchedDetail?.Container) || 0;

            const { Quantity, Rate, Net_weight } = updatedDetail;

            //Call calculateDetails with container flags
            const {
                Amount,
                MarketCess,
                DekhRekh,
                Hamali,
                Tolai,
                Hamali_Rate,
                Tolai_Rate,
                Leavy,
                containerAmt,
            } = await calculateDetails(
                Quantity,
                Rate,
                Net_weight,
                Market_Rate,
                Dekrekh_Rate,
                hamali,
                tolai,
                Leavy_Rate,
                formDataDetail.isNetWeightManuallyChanged,
                formDataDetail.Net_weight,
                formDataDetail.isContainerManuallyChanged,
                updatedDetail.containerAmt,
                containerValue
            );

            //Update state with manual flags for NetWt & container
            setFormDataDetail((prev) => {
                let isNetWeightManuallyChanged = prev.isNetWeightManuallyChanged;
                let isContainerManuallyChanged = prev.isContainerManuallyChanged;

                // If user edits Net_weight → mark manual
                if (name === "Net_weight") isNetWeightManuallyChanged = true;

                // Reset Net_weight manual flag if Quantity or wtpr changes
                if (name === "Quantity" || name === "wtpr") isNetWeightManuallyChanged = false;

                // If user edits container → mark manual
                if (name === "containerAmt") {
                    isContainerManuallyChanged = true;
                }

                // If user edits container OR Quantity → auto recalc
                if (name === "container" || name === "Quantity") {
                    isContainerManuallyChanged = false;
                }
                return {
                    ...prev,
                    [name]: newValue,
                    Amount,
                    Net_weight: updatedDetail.Net_weight,
                    Market_Cess: MarketCess,
                    Dekrekh: DekhRekh,
                    Hamali,
                    Tolai,
                    hamalical: Hamali_Rate,
                    Tolaical: Tolai_Rate,
                    leavy: Leavy,
                    container: containerValue,
                    containerAmt,
                    Market_Rate,
                    Dekrekh_Rate,
                    Leavy_Rate,
                    isNetWeightManuallyChanged,
                    isContainerManuallyChanged,
                };
            });

            //Update dependent values in head form (unchanged)
            const updatedFormData = await calculateDependentValues(name, value, formData);
            setFormData((prev) => ({
                ...prev,
                ...updatedFormData,
            }));
        }
    };


    console.log("formDataDetail", formDataDetail)


    const checkPattiNoandIdUsage = async (Patti_No, Patti_Id) => {
        try {
            const res = await axios.get(`${API_URL}/check-PattiNousedinGulSaleBill-usage`, {
                params: {
                    Patti_No: Patti_No,
                    Company_Code: companyCode,
                    Patti_Id: Patti_Id,
                },
            });

            return res.data?.isUsed ?? false;
        } catch (err) {
            console.error("Error checking Proforma usage:", err);
            return false; // Fail-safe
        }
    };

    const checkAwakNoUsage = async (awakdetailId) => {
        if (!awakdetailId || awakdetailId <= 0) {
            console.error("Invalid Awak_No:", awakdetailId);
            return { isUsed: false };
        }
        if (!companyCode) {
            console.error("Missing Company_Code:", companyCode);
            return { isUsed: false };
        }

        try {
            const res = await axios.get(`${API_URL}/check-AwakNoFromGulSaleBill-usage`, {
                params: {
                    Awak_Id: awakdetailId,
                    Company_Code: companyCode,
                },
            });

            return res.data || { isUsed: false };
        } catch (err) {
            console.error("Error checking Awak No usage:", err);
            return { isUsed: false };
        }
    };




    const handleOnChange = () => {
        setIsChecked((prev) => {
            const newValue = !prev;
            const value = newValue ? "Y" : "N";

            setFormData((prevData) => ({
                ...prevData,
                EWayBill_Chk: value,
            }));
            return newValue;
        });
    };

    //handle the Date OnChange Values
    const handleDateChange = (event, fieldName) => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            [fieldName]: event.target.value,
        }));
    };

    // useEffect(() => {
    //     if (isHandleChange) {
    //         handleCancel();
    //         setIsHandleChange(false);
    //     }
    // }, []);

    //fetchLast Records to get the next doc no
    const fetchLastRecord = () => {
        fetch(
            `${API_URL}/get-next-doc-no-forGulSaleBill?Company_Code=${companyCode}&Year_Code=${Year_Code}&Tran_Type=${TranType || formData.Tran_Type}`
        )
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to fetch last record");
                }
                return response.json();
            })
            .then((data) => {
                const newDocNo = data.next_doc_no;
                setFormData((prevState) => ({
                    ...prevState,
                    doc_no: newDocNo,
                }));
            })
            .catch((error) => {
                console.error("Error fetching last record:", error);
            });
    };

    //handle record Add.
    const handleAddOne = async () => {
        setAddOneButtonEnabled(false);
        setSaveButtonEnabled(true);
        setCancelButtonEnabled(true);
        setEditButtonEnabled(false);
        setDeleteButtonEnabled(false);
        setIsEditMode(false);
        setIsEditing(true);
        fetchLastRecord();
        setFormData(initialFormData);
        partyName = "";
        AwakNo = "";
        Awakid = "";
        millName = "";
        millCode = "";
        unitName = "";
        unitCode = "";
        brokerName = "";
        brokerCode = "";
        itemName = "";
        item_Code = "";
        brandName = "";
        brandCode = "";
        billToName = "";
        billToCode = "";
        setLastTenderDetails([]);
        setTimeout(() => {
            inputRef.current?.focus();
        }, 0);
    };

    //handle Edit record functionality.
    const handleEdit = async () => {
        const Post_Date = sessionStorage.getItem("Post_Date");
        const Outword_Date = sessionStorage.getItem("Outword_Date")
        if (await OutwordPostDateRecordLock(formData.doc_date, Post_Date, Outword_Date)) {
            return;
        }

        if (
            (formData.einvoiceno && formData.einvoiceno.trim() !== "" && formData.ackno && formData.ackno.trim() !== "") ||
            (formData.EWay_Bill_No && formData.EWay_Bill_No.trim() !== "")
        ) {
            let message = "";

            if (formData.einvoiceno && formData.einvoiceno.trim() !== "" && formData.ackno && formData.ackno.trim() !== "") {
                message += "E-Invoice has already been generated for this record.";
            }

            if (formData.EWay_Bill_No && formData.EWay_Bill_No.trim() !== "") {
                message += (message ? "\n" : "") + "E-WayBill has already been generated for this record.";
            }

            Swal.fire({
                icon: "warning",
                text: message,
                confirmButtonColor: "#d33",
            });

        }
        axios.get(`${API_URL}/GulSaleBillByid?salebillId=${formData.salebillId}&Company_Code=${companyCode}&Year_Code=${Year_Code}&Tran_Type=${formData.Tran_Type}`)
            .then(async (response) => {
                const data = response.data;
                const isLockedNew = data.last_head_data.LockedRecord;
                const isLockedByUserNew = data.last_head_data.LockedUser;

                if (isLockedNew) {
                    Swal.fire({
                        icon: "warning",
                        title: "Record Locked",
                        text: `This record is locked by ${isLockedByUserNew}`,
                        confirmButtonColor: "#d33",
                    });
                    return
                }
                else {
                    lockRecord();
                }
                setFormData({
                    ...formData,
                    ...data.last_head_data
                });
                setMarketCessApplicable(await fetchMarketCessApplicable(data.last_head_data.Ac_Code));
                setIsEditMode(true);
                setAddOneButtonEnabled(false);
                setSaveButtonEnabled(true);
                setCancelButtonEnabled(true);
                setEditButtonEnabled(false);
                setDeleteButtonEnabled(false);
                setBackButtonEnabled(true);
                setIsEditing(true);
            })
            .catch((error) => {
                window.alert("This record is already deleted! Showing the previous record.");
            });
    };

    const showAlert = async (title, text, icon = "warning") => {
        setIsLoading(false);
        await Swal.fire({
            title,
            text,
            icon,
            confirmButtonText: "OK",
        });
    };

    // Record save and update functionality
    const handleSaveOrUpdate = async () => {

        if (await OutwordPostDateRecordLock(formData.doc_date, Post_Date, Outword_Date)) {
            return;
        }

        const accountingYearData = sessionStorage.getItem('Accounting_Year');
        const formattedEntryDate = formData.doc_date;
        const isValid = validateDocumentDate(formattedEntryDate, accountingYearData);

        if (!isValid) {
            return
        }

        if (users.length === 0 || users.every(user => user.rowaction === "DNU" || user.rowaction === "delete")) {
            Swal.fire({
                text: "Please add at least one entry in the detail grid.",
                icon: "warning",
                confirmButtonText: "OK"
            });
            return;
        }

        const invalidRow = users.find(user =>
            (user.rowaction !== "DNU" && user.rowaction !== "delete") &&
            (!user.Net_weight || Number(user.Net_weight) === 0)
        );

        if (invalidRow) {
            Swal.fire({
                title: "Missing Net Weight",
                text: `Please add Net Weight for:
                ID: ${invalidRow.salebilldetailId}
                Awak No: ${invalidRow.Awak_No}`,
                icon: "warning",
                confirmButtonText: "OK"
            });

            return;
        }


        const invalidItemRow = users.find(user =>
            (user.rowaction !== "DNU" && user.rowaction !== "delete") &&
            (!user.Item_Code || Number(user.Item_Code) === 0)
        );
        if (invalidItemRow) {
            Swal.fire({
                title: "Missing Item Code",
                text: `Item Code is required for row ID: ${invalidItemRow.detail_id}, Awak No: ${invalidItemRow.Awak_No}. Please select an Item.`,
                icon: "warning",
                confirmButtonText: "OK"
            });
            return;
        }

        const invalidLineRow = users.find(user =>
            (user.rowaction !== "DNU" && user.rowaction !== "delete") &&
            (!user.Linecode || Number(user.Linecode) === 0)
        );
        if (invalidLineRow) {
            Swal.fire({
                title: "Missing Line Code",
                text: `Line Code is required for row ID: ${invalidLineRow.detail_id}, Awak No: ${invalidLineRow.Awak_No}. Please select a Line.`,
                icon: "warning",
                confirmButtonText: "OK"
            });
            return;
        }

        setIsEditing(true);
        setIsLoading(true);


        let headData = {
            ...formData,
            // GstRateCode: gstCode || gstRateCode,
            // RateDiff: formData.RateDiff || 0,
            ...(isEditMode
                ? {
                    Modified_By: username,

                    // User_Id: User_Id
                }
                : {
                    Created_By: username
                }
            )
        };

        if (isEditMode) {
            delete headData.salebillId;
        }
        const detailData = users.map((user) => ({
            rowaction: user.rowaction,
            salebilldetailId: user.salebilldetailId,
            Item_Code: user.Item_Code,
            ic: user.ic,
            Awak_No: user.Awak_No,
            Awak_Id: user.Awak_Id,
            awakdetailId: user.awakdetailId,
            // salebilldetailId: 1,
            Market_Cess: user.Market_Cess,
            Dekrekh: user.Dekrekh,
            Market_Rate: user.Market_Rate,
            Dekrekh_Rate: user.Dekrekh_Rate,
            container: user.container,
            containerAmt: user.containerAmt,
            Hamali: user.Hamali,
            Tolai: user.Tolai,
            leavy: user.leavy,
            Leavy_Rate: user.Leavy_Rate,
            Company_Code: companyCode,
            Year_Code: Year_Code,
            Modified_By: username,
            Created_By: username,
            wtpr: user.wtpr,
            Quantity: user.Quantity,
            QuantitytoShow: user.QuantitytoShow,
            Net_weight: user.Net_weight,
            wtpr: user.wtpr,
            Rate: user.Rate,
            Amount: user.Amount,
            Linecode: user.Linecode,
            lc: user.lc,
            Farmer_Code: user.Farmer_Code,
            fc: user.fc,
            Patti_No: user.Patti_No,
            Patti_Id: user.Patti_Id,
            additionNetWt: user.additionNetWt,
            GrossWt: user.GrossWt,
            tolaidarName: user.tolaidarName,
            BagSut: user.BagSut,
            ExtraSut: user.ExtraSut,
            detail_id: user.detail_id,
            hamalical: user.hamalical,
            Tolaical: user.Tolaical,
            awkid: user.awkid,
            KattaPatti: user.KattaPatti,
            SrNo: user.SrNo,
            Tran_Type: user.Tran_Type,
            // Display_FarmerName: user.Display_FarmerName,
            // Display_AwakDate: user.Display_AwakDate,
            // Display_AwakQty: user.Display_AwakQty,
        }));



        const requestData = {
            headData,
            detailData,
        };

        try {
            if (isEditMode) {
                const updateApiUrl = `${API_URL}/update-GulSaleBill?salebillId=${newsalebillId}&Tran_Type=${formData.Tran_Type || TranType}`;
                const response = await axios.put(updateApiUrl, requestData);

                unlockRecord();
                Swal.fire({
                    title: "Success!",
                    text: "Record updated successfully!",
                    icon: "success",
                    confirmButtonText: "OK"
                });

                setTimeout(() => {
                    window.onbeforeunload = null;
                    window.location.reload();
                }, 1000);
                navigate(`/Haladsale-bill?navigatedRecord=${formData.doc_no}&navigatedTranType=${formData.Tran_Type || TranType}`);
            } else {
                const response = await axios.post(
                    `${API_URL}/insert-GulSaleBill`,
                    requestData
                );
                Swal.fire({
                    title: "Success!",
                    text: "Record saved successfully!",
                    icon: "success",
                    confirmButtonText: "OK"
                });
                setIsEditMode(false);
                setAddOneButtonEnabled(true);
                setEditButtonEnabled(true);
                setDeleteButtonEnabled(true);
                setBackButtonEnabled(true);
                setSaveButtonEnabled(false);
                setCancelButtonEnabled(false);
                setIsEditing(true);

                setTimeout(() => {
                    window.location.reload();
                }, 1000);
                navigate(`/Haladsale-bill?navigatedRecord=${formData.doc_no}&navigatedTranType=${formData.Tran_Type || TranType}`);
            }
        } catch (error) {
            console.error("Error during API call:", error);
            toast.error("Error occurred while saving data");
        } finally {
            setIsEditing(false);
            setIsLoading(false);
        }
    };


    const handleDelete = async (user) => {


        const isUsed = await checkPattiNoandIdUsage(
            PattiNo,
            PattiId
        );

        if (isUsed) {
            Swal.fire({
                icon: "error",
                title: "Cannot Delete",
                text: "This Sale Bill Has its Patti Entry. You cannot delete it.",
                confirmButtonColor: "#d33",
            });
            return;
        }

        const awakNo = user.awakdetailId;

        // if (!awakNo || awakNo <= 0) {
        //     Swal.fire({
        //         icon: "error",
        //         title: "Cannot Delete",
        //         text: "Awak No is Used in Advance. Cannot perform deletion.",
        //         confirmButtonColor: "#d33",
        //     });
        //     return;
        // }

        const usage = await checkAwakNoUsage(awakNo);
        if (usage.isUsed) {
            Swal.fire({
                icon: "error",
                title: "Cannot Delete",
                text: "This Awak No is already used in Awak Advance. You cannot delete it.",
                confirmButtonColor: "#d33",
            });
            return;
        }

        if (await OutwordPostDateRecordLock(formData.doc_date, Post_Date, Outword_Date)) {
            return;
        }


        try {
            const response = await axios.get(
                `${API_URL}/GulSaleBillByid?salebillId=${newsalebillId}&Company_Code=${companyCode}&Year_Code=${Year_Code}&Tran_Type=${TranType || formData.Tran_Type}`
            );

            const data = response.data;
            const isLockedNew = data.last_head_data.LockedRecord;
            const isLockedByUserNew = data.last_head_data.LockedUser;

            if (isLockedNew) {
                Swal.fire({
                    title: "Record Locked",
                    text: `This record is locked by ${isLockedByUserNew}`,
                    icon: "warning",
                    confirmButtonText: "OK",
                });
                return;
            }

            const result = await Swal.fire({
                title: "Are you sure?",
                text: `Do you really want to delete this Doc No: ${formData.doc_no}?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                cancelButtonText: "Cancel",
                confirmButtonText: "Delete",
                reverseButtons: true,
                focusCancel: true,
            });

            if (result.isConfirmed) {
                setIsEditMode(false);
                setAddOneButtonEnabled(true);
                setEditButtonEnabled(true);
                setDeleteButtonEnabled(true);
                setBackButtonEnabled(true);
                setSaveButtonEnabled(false);
                setCancelButtonEnabled(false);
                setIsLoading(true);

                const deleteApiUrl = `${API_URL}/delete_data_by_Gulsaleid?salebillId=${newsalebillId}&Company_Code=${companyCode}&doc_no=${formData.doc_no}&Year_Code=${Year_Code}&Tran_Type=${TranType || formData.Tran_Type}`;
                const deleteResponse = await axios.delete(deleteApiUrl);

                if (deleteResponse.status === 200) {
                    if (deleteResponse.data) {
                        Swal.fire({
                            title: "Deleted!",
                            text: "Data deleted successfully!",
                            icon: "success",
                            confirmButtonText: "OK",
                        });
                        handleCancel();
                    }
                    const docNoNum = parseInt(formData.doc_no);
                    if (!docNoNum || docNoNum <= 1) {
                        handleAddOne();
                    } else {

                        handleCancel();
                    }
                } else {
                    Swal.fire({
                        title: "Error",
                        text: "Failed to delete the record.",
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                }
            } else {
                Swal.fire({
                    title: "Cancelled",
                    text: "Your record is safe 🙂",
                    icon: "info",
                    confirmButtonText: "OK",
                });
            }
        } catch (error) {
            console.error("Error during API call:", error);
            Swal.fire({
                title: "Error",
                text: `There was an error during the deletion: ${error.message}`,
                icon: "error",
                confirmButtonText: "OK",
            });
        } finally {
            setIsLoading(false);
        }
    };


    //Common Feilds that we haev to set the record on the navigations.
    const NavigationSetFields = async (headData, detailData) => {

        const details = detailData[0];
        newsalebillId = headData.salebillId;
        partyName = details.partyname;
        AwakNo = details.Awak_No;
        Awakid = details.Awak_Id;
        unitName = details.unitname;
        unitCode = details.unitaccode;
        billToName = details.CustomerCodeName;
        billToCode = headData.Customer_Code;
        millName = details.AccountCodeName;
        millCode = headData.Ac_Code;
        itemName = details.itemName;
        item_Code = details.Item_Code;
        brandName = details.System_Name_E;
        brandCode = details.Linecode;
        brokerCode = details.Broker_code;
        brokerName = details.BrokerCodeName;
        millgstno = details.MillGSTNo;
        FarmerCode = details.Farmer_Code;
        fc = details.fc;
        PattiNo = details.Patti_No;
        PattiId = details.Patti_Id;

        setFormData((prevData) => ({
            ...prevData,
            ...headData,
        }));

        setMarketCessApplicable(await fetchMarketCessApplicable(headData.Ac_Code));

        setLastTenderData(headData || {});
        setLastTenderDetails(detailData || []);
    };

    // handle cancel get last record data and set to
    const handleCancel = async () => {

        setIsEditing(false);
        setIsEditMode(false);
        setAddOneButtonEnabled(true);
        setEditButtonEnabled(true);
        setDeleteButtonEnabled(true);
        setBackButtonEnabled(true);
        setSaveButtonEnabled(false);
        setCancelButtonEnabled(false);
        setCancelButtonClicked(true);

        try {
            const response = await axios.get(
                `${API_URL}/get-GullastSaleBill-navigation?Company_Code=${companyCode}&Year_Code=${Year_Code}&Tran_Type=${TranType}`
            );
            if (response.status === 200) {
                const data = response.data;
                NavigationSetFields(data.last_head_data, data.last_details_data);
                setIsChecked(true);
                unlockRecord();
            } else {
                console.error(
                    "Failed to fetch last data:",
                    response.status,
                    response.statusText
                );
            }
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };

    // handle back button to navigate to the dashboard page.
    const handleBack = () => {
        navigate("/HaladSaleBill-utility", { state: { Tran_Type: formData.Tran_Type || TranType } });
    };

    // Navigation Funtionality 
    const handleFirstButtonClick = async () => {
        try {
            const response = await axios.get(
                `${API_URL}/get-GulfirstSaleBill-navigation?Company_Code=${companyCode}&Year_Code=${Year_Code}&Tran_Type=${TranType || formData.Tran_Type}`
            );
            if (response.status === 200) {
                const data = response.data;
                NavigationSetFields(data.first_head_data, data.first_details_data);
            } else {
                console.error(
                    "Failed to fetch first tender data:",
                    response.status,
                    response.statusText
                );
            }
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };

    const handleLastButtonClick = async () => {
        try {
            const response = await axios.get(
                `${API_URL}/get-GullastSaleBill-navigation?Company_Code=${companyCode}&Year_Code=${Year_Code}&Tran_Type=${TranType || formData.Tran_Type}`
            );
            if (response.status === 200) {
                const data = response.data;
                NavigationSetFields(data.last_head_data, data.last_details_data);
            } else {
                console.error(
                    "Failed to fetch last tender data:",
                    response.status,
                    response.statusText
                );
            }
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };

    const handleNextButtonClick = async () => {
        try {
            const response = await axios.get(
                `${API_URL}/get-GulnextSaleBill-navigation?Company_Code=${companyCode}&Year_Code=${Year_Code}&currentDocNo=${formData.doc_no}&Tran_Type=${TranType || formData.Tran_Type}`
            );
            if (response.status === 200) {
                const data = response.data;
                NavigationSetFields(data.next_head_data, data.next_details_data);
            } else {
                console.error(
                    "Failed to fetch next tender data:",
                    response.status,
                    response.statusText
                );
            }
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };

    const handlePreviousButtonClick = async () => {
        try {
            const response = await axios.get(
                `${API_URL}/get-GulpreviousSaleBill-navigation?Company_Code=${companyCode}&Year_Code=${Year_Code}&currentDocNo=${formData.doc_no}&Tran_Type=${TranType || formData.Tran_Type}`
            );

            if (response.status === 200) {
                const data = response.data;
                NavigationSetFields(data.previous_head_data, data.previous_details_data);
            } else {
                console.error(
                    "Failed to fetch previous tender data:",
                    response.status,
                    response.statusText
                );
            }
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
    };

    useEffect(() => {

        if (selectedRecord) {
            handlerecordDoubleClicked();
        }
        else if (navigatedRecord && !isNaN(navigatedRecord) && parseInt(navigatedRecord) > 0) {
            handleNavigateRecord();
        }
        else {
            handleAddOne();
        }
    }, [selectedRecord, navigatedRecord]);


    // useEffect(() => {
    //     if (selectedRecord) {
    //         handlerecordDoubleClicked();
    //     } else {
    //         handleAddOne();
    //     }
    // }, [selectedRecord]);


    const handlerecordDoubleClicked = async () => {

        setTranType(selectedRecord.Tran_Type);
        setIsEditing(false);
        setIsEditMode(false);
        setAddOneButtonEnabled(true);
        setEditButtonEnabled(true);
        setDeleteButtonEnabled(true);
        setBackButtonEnabled(true);
        setSaveButtonEnabled(false);
        setCancelButtonEnabled(false);
        setCancelButtonClicked(true);
        try {
            const response = await axios.get(
                `${API_URL}/GulSaleBillByid?salebillId=${selectedRecord.salebillId}&Company_Code=${companyCode}&Year_Code=${Year_Code}&Tran_Type=${selectedRecord.Tran_Type}`
            );
            if (response.status === 200) {
                const data = response.data;

                newsalebillId = data.last_head_data.salebillId;
                partyName = data.last_details_data[0].partyname;
                AwakNo = data.last_details_data[0].Awak_No;
                Awakid = data.last_details_data[0].Awak_Id;
                unitName = data.last_details_data[0].unitname;
                unitCode = data.last_details_data[0].unitaccode;
                billToName = data.last_details_data[0].CustomerCodeName;
                billToCode = data.last_head_data.Customer_Code;
                millName = data.last_details_data[0].AccountCodeName;
                millCode = data.last_head_data.Ac_Code;
                itemName = data.last_details_data[0].itemName;
                item_Code = data.last_details_data[0].Item_Code;
                brandName = data.last_details_data[0].System_Name_E;
                brandCode = data.last_details_data[0].Linecode;
                brokerCode = data.last_head_data.Broker_code;
                brokerName = data.last_details_data[0].BrokerCodeName;
                millgstno = data.last_details_data[0].MillGSTNo;
                PattiNo = data.last_details_data[0].Patti_No;
                PattiId = data.last_details_data[0].Patti_Id;

                setFormData((prevData) => ({
                    ...prevData,
                    ...data.last_head_data,
                }));
                setMarketCessApplicable(await fetchMarketCessApplicable(data.last_head_data.Ac_Code));
                setLastTenderData(data.last_head_data || {});
                setLastTenderDetails(data.last_details_data || []);
            } else {
                console.error(
                    "Failed to fetch last tender data:",
                    response.status,
                    response.statusText
                );
            }
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };

    const handleNavigateRecord = async () => {
        setIsEditing(false);
        setIsEditMode(false);
        setAddOneButtonEnabled(true);
        setEditButtonEnabled(true);
        setDeleteButtonEnabled(true);
        setBackButtonEnabled(true);
        setSaveButtonEnabled(false);
        setCancelButtonEnabled(false);
        setCancelButtonClicked(true);
        try {
            const response = await axios.get(
                `${API_URL}/GulSaleBillByDocNo?doc_no=${navigatedRecord}&Company_Code=${companyCode}&Year_Code=${Year_Code}&Tran_Type=${navigatedTranType}`
            );
            if (response.status === 200) {
                const data = response.data;

                newsalebillId = data.last_head_data.salebillId;
                partyName = data.last_details_data[0].partyname;
                AwakNo = data.last_details_data[0].Awak_No;
                Awakid = data.last_details_data[0].Awak_Id;
                unitName = data.last_details_data[0].unitname;
                unitCode = data.last_details_data[0].unitaccode;
                billToName = data.last_details_data[0].CustomerCodeName;
                billToCode = data.last_head_data.Customer_Code;
                millName = data.last_details_data[0].AccountCodeName;
                millCode = data.last_head_data.Ac_Code;
                itemName = data.last_details_data[0].itemName;
                item_Code = data.last_details_data[0].Item_Code;
                brandName = data.last_details_data[0].System_Name_E;
                brandCode = data.last_details_data[0].Linecode;
                brokerCode = data.last_head_data.Broker_code;
                brokerName = data.last_details_data[0].BrokerCodeName;
                millgstno = data.last_details_data[0].MillGSTNo;
                FarmerCode = data.last_details_data[0].Farmer_Code;
                PattiNo = data.last_details_data[0].Patti_No;
                PattiId = data.last_details_data[0].Patti_Id;
                setFormData((prevData) => ({
                    ...prevData,
                    ...data.last_head_data,
                }));
                setMarketCessApplicable(await fetchMarketCessApplicable(data.last_head_data.Ac_Code));
                setLastTenderData(data.last_head_data || {});
                setLastTenderDetails(data.last_details_data || []);
            } else {
                console.error(
                    "Failed to fetch last tender data:",
                    response.status,
                    response.statusText
                );
            }
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };

    const handleDropdownChange = async (event) => {
        const selectedValue = event.target.value;

        setTranType(selectedValue);

        setFormData((prevData) => ({
            ...prevData,
            Tran_Type: selectedValue,
        }));

        const url = `${API_URL}/get-GullastSaleBill-navigation?Company_Code=${companyCode}&Year_Code=${Year_Code}&Tran_Type=${selectedValue}`;

        try {
            const response = await fetch(url);
            const data = await response.json();

            const headData = data.last_head_data;
            const detailData = data.last_details_data;

            NavigationSetFields(headData, detailData);
        } catch (error) {
            console.error("Navigation API error:", error);
        }
    };

    const handleKeyDown = async (event) => {
        if (event.key === "Tab") {
            const changeNoValue = event.target.value;
            try {
                const response = await axios.get(
                    `${API_URL}/GulSaleBillByDocNo?doc_no=${changeNoValue}&Company_Code=${companyCode}&Year_Code=${Year_Code}&Tran_Type=${TranType}`
                );
                const data = response.data;
                newsalebillId = data.last_head_data.salebillId;
                partyName = data.last_details_data[0].partyname;
                AwakNo = data.last_details_data[0].Awak_No;
                Awakid = data.last_details_data[0].Awak_Id;
                unitName = data.last_details_data[0].unitname;
                unitCode = data.last_details_data[0].unitaccode;
                billToName = data.last_details_data[0].CustomerCodeName;
                billToCode = data.last_head_data.Customer_Code;
                millName = data.last_details_data[0].AccountCodeName;
                millCode = data.last_head_data.Ac_Code;
                itemName = data.last_details_data[0].itemName;
                item_Code = data.last_details_data[0].Item_Code;
                brandName = data.last_details_data[0].System_Name_E;
                brandCode = data.last_details_data[0].Linecode;
                brokerCode = data.last_head_data.Broker_code;
                brokerName = data.last_details_data[0].BrokerCodeName;
                millgstno = data.last_details_data[0].MillGSTNo;
                PattiNo = data.last_details_data[0].Patti_No;
                PattiId = data.last_details_data[0].Patti_Id;


                setFormData({
                    ...formData,
                    ...data.last_head_data,
                });
                setLastTenderData(data.last_head_data || {});
                setLastTenderDetails(data.last_details_data || []);
                setIsEditing(false);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }
    };

    const checkMatchStatus = async (ac_code, company_code, year_code) => {
        try {
            const { data } = await axios.get(
                `${process.env.REACT_APP_API}/get_match_status`,
                {
                    params: {
                        Ac_Code: ac_code,
                        Company_Code: company_code,
                        Year_Code: year_code,
                    },
                }
            );
            return data.match_status;
        } catch (error) {
            console.error("Couldn't able to match GST State Code:", error);
            return error;
        }
    };

    useEffect(() => {
        if (!isChecked) {
            fetchCompanyGSTCode(companyCode);
        }
    }, [isChecked, companyCode]);


    const fetchMarketCessApplicable = async (ac_code) => {
        if (!ac_code) return 'N';
        try {
            const { data } = await axios.get(`${API_URL}/get-account-marketcess`, {
                params: { Ac_Code: ac_code, Company_Code: companyCode },
            });
            return (data?.MarketCess || 'N').toString().trim().toUpperCase();
        } catch (error) {
            console.error("Error fetching MarketCess flag:", error);
            return 'N';
        }
    };

    const fetchCompanyGSTCode = async (company_code) => {
        try {
            const { data } = await axios.get(
                `${API_URL}/get_company_by_code?company_code=${company_code}`
            );
            setGstNo(data.GST);
        } catch (error) {
            console.error("Error:", error);
            setGstNo("");
        }
    };




    const calculateDependentValues = async (name, input, formData) => {

        if (
            ["Quantity", "Rate", "wtpr", "Amount", "Net_weight", "Market_Cess", "Dekrekh", "leavy", "tolaidarName", "GrossWt", "KattaPatti"].includes(name)
        ) {
            return formData;
        }

        const updatedFormData = { ...formData, [name]: input };

        const totalamt = Number(updatedFormData.SubTotal) || 0;
        const hamaliamt = Number(updatedFormData.HamaliAmt) || 0;
        const tolaiamt = Number(updatedFormData.TolaiAmt) || 0;
        const Commission_Rate = Number(updatedFormData.Commission_Rate) || 0;
        const Leavy = Number(updatedFormData.Leavy) || 0;
        const conta = Number(updatedFormData.Container) || 0;
        const hamali = Number(updatedFormData.HamaliAmt) || 0;
        const tolai = Number(updatedFormData.TolaiAmt) || 0;
        const marketCessAmt = Number(updatedFormData.MarketCess) || 0;
        updatedFormData.Leavy = Leavy.toFixed(2);

        const commissionamt = (totalamt * Commission_Rate) / 100;
        // const roundedComission = Math.round(commissionamt * 100) / 100;

        const Expense = Leavy + commissionamt;
        // const billamt = Expense + totalamt + conta + hamaliamt + tolaiamt;
        let billamt =
            hamaliSaleRate === "Y"
                ? Expense + totalamt + conta + hamaliamt + tolaiamt
                : Expense + totalamt + conta;

        if (marketCessApplicable === "Y") {
            billamt += marketCessAmt;
        }

        const roundedBillAmount = Math.round(billamt);

        const roundOff = roundedBillAmount - billamt;

        updatedFormData.Commission = commissionamt.toFixed(2);
        updatedFormData.Expense_Subtotal = Expense.toFixed(2);
        updatedFormData.Bill_Amount = roundedBillAmount.toFixed(2);
        updatedFormData.RoundOff = roundOff.toFixed(2);

        const tdsRate = parseFloat(updatedFormData.TDS_Rate) || 0.0;
        updatedFormData.TDS_Amt = Math.round(
            (updatedFormData.Commission * tdsRate) /
            100
        );
        updatedFormData.TDS_Rate = tdsRate;

        console.log({ totalamt, Commission_Rate, Leavy, commissionamt, commissionamt, Expense, billamt });

        return updatedFormData;
    };


    //-------------------------------------------- Detail Section Start ----------------------------------------------------
    useEffect(() => {
        if (selectedRecord) {
            setUsers(
                lastTenderDetails.map((detail) => ({
                    Item_Code: detail.Item_Code,
                    item_Name: detail.itemName,
                    rowaction: "Normal",
                    Linecode: detail.Linecode,
                    Tran_Type: detail.Tran_Type || TranType,
                    brand_name: detail.System_Name_E,
                    ic: detail.ic,
                    id: detail.salebilldetailId,
                    salebilldetailId: detail.salebilldetailId,
                    Quantity: detail.Quantity,
                    QuantitytoShow: detail.QuantitytoShow,
                    Net_weight: detail.Net_weight,
                    wtpr: detail.wtpr,
                    Rate: detail.Rate,
                    Awak_No: detail.Awak_No,
                    Awak_Id: detail.Awak_Id,
                    Amount: detail.Amount,
                    Farmer_Code: detail.Farmer_Code,
                    fc: detail.fc,
                    Market_Cess: detail.Market_Cess,
                    container: detail.container,
                    containerAmt: detail.containerAmt,
                    Dekrekh: detail.Dekrekh,
                    Market_Rate: detail.Market_Rate,
                    Dekrekh_Rate: detail.Dekrekh_Rate,
                    Hamali: detail.Hamali,
                    Tolai: detail.Tolai,
                    Leavy_Rate: detail.Leavy_Rate,
                    leavy: detail.leavy,
                    Patti_No: detail.Patti_No,
                    Patti_Id: detail.Patti_Id,
                    additionNetWt: detail.additionNetWt,
                    GrossWt: detail.GrossWt,
                    tolaidarName: detail.tolaidarName,
                    BagSut: detail.BagSut,
                    ExtraSut: detail.ExtraSut,
                    awakdetailId: detail.awakdetailId,
                    detail_id: detail.detail_id,
                    hamalical: detail.hamalical,
                    Tolaical: detail.Tolaical,
                    awkid: detail.awkid,
                    KattaPatti: detail.KattaPatti,
                    SrNo: detail.SrNo,
                }))
            );
        }
    }, [selectedRecord, lastTenderDetails]);

    useEffect(() => {
        const updatedUsers = lastTenderDetails.map((detail) => ({
            Item_Code: detail.Item_Code,
            item_Name: detail.itemName,
            rowaction: "Normal",
            Linecode: detail.Linecode,
            Tran_Type: detail.Tran_Type || TranType,
            brand_name: detail.System_Name_E,
            ic: detail.ic,
            id: detail.salebilldetailId,
            salebilldetailId: detail.salebilldetailId,
            Quantity: detail.Quantity,
            QuantitytoShow: detail.QuantitytoShow,
            Net_weight: detail.Net_weight,
            wtpr: detail.wtpr,
            Rate: detail.Rate,
            Awak_No: detail.Awak_No,
            Awak_Id: detail.Awak_Id,
            Amount: detail.Amount,
            Farmer_Code: detail.Farmer_Code,
            fc: detail.fc,
            Market_Cess: detail.Market_Cess,
            container: detail.container,
            containerAmt: detail.containerAmt,
            Dekrekh: detail.Dekrekh,
            Market_Rate: detail.Market_Rate,
            Dekrekh_Rate: detail.Dekrekh_Rate,
            Hamali: detail.Hamali,
            Tolai: detail.Tolai,
            Leavy_Rate: detail.Leavy_Rate,
            leavy: detail.leavy,
            Patti_No: detail.Patti_No,
            Patti_Id: detail.Patti_Id,
            additionNetWt: detail.additionNetWt,
            GrossWt: detail.GrossWt,
            tolaidarName: detail.tolaidarName,
            BagSut: detail.BagSut,
            ExtraSut: detail.ExtraSut,
            awakdetailId: detail.awakdetailId,
            detail_id: detail.detail_id,
            hamalical: detail.hamalical,
            Tolaical: detail.Tolaical,
            awkid: detail.awkid,
            KattaPatti: detail.KattaPatti,
            SrNo: detail.SrNo,
        }));
        setUsers(updatedUsers);
    }, [lastTenderDetails]);

    const calculateTotals = (users) => {
        return users.reduce(
            (totals, user) => {
                if (user.rowaction !== "delete" && user.rowaction !== "DNU") {
                    totals.totalamt += parseFloat(user.Amount || 0);
                    totals.totalQty += parseFloat(user.Quantity || 0.00);
                    totals.totalNetwt += parseFloat(user.Net_weight || 0);
                    totals.totalMrktcess += parseFloat(user.Market_Cess || 0);
                    totals.totaldekhRek += parseFloat(user.Dekrekh || 0);
                    totals.totalleavy += parseFloat(user.leavy || 0);
                    totals.totalcont += parseFloat(user.containerAmt || 0);
                    totals.totalhamali += parseFloat(user.hamalical || 0);
                    totals.totaltolai += parseFloat(user.Tolaical || 0);
                }
                return totals;
            },
            { totalamt: 0, totalQty: 0, totalNetwt: 0, totalMrktcess: 0, totaldekhRek: 0, totalleavy: 0, totalcont: 0, totalhamali: 0, totaltolai: 0, }
        );
    };

    const { totalamt, totalNetwt, totalQty, totalMrktcess, totaldekhRek, totalleavy, totalcont, totalhamali, totaltolai } = calculateTotals(users);



    // const calculateDetails = (Quantity, Rate, wtpr) => {
    //     
    //     const CheckRateper = checkLoadingGst(companyCode, itemCode || formDataDetail.Item_Code);
    //     console.log("CheckRateper", CheckRateper)
    //     var NetWt = Quantity * wtpr
    //     if (CheckRateper.RatePer === "Q") {
    //         var Amount = Quantity * Rate;
    //     }
    //     else {
    //         var Amount = (NetWt / 100) * Rate;
    //     }


    //     return { Amount, NetWt };
    // };

    const handleAdditionNetWtChange = (value) => {
        const parts = (value || "")
            .split("+")
            .map(v => v.trim())
            .filter(v => v !== "");

        const sum = parts.reduce((acc, v) => acc + parseFloat(v || 0), 0);
        const countAddNetWt = parts.length * 0.5;

        const grossWt = parseFloat(sum.toFixed(2));
        const netWt = parseFloat((sum - countAddNetWt).toFixed(2));

        setFormDataDetail(prev => ({
            ...prev,
            additionNetWt: value,
            GrossWt: grossWt,
            Net_weight: netWt,
            isNetWeightManuallyChanged: true
        }));
    };


    const calculateDetails = async (Quantity, Rate, Net_weight, Market_Rate, Dekrekh_Rate, Hamali, Tolai, Leavy_Rate, manualNetWtChanged = false,
        manualNetWtValue = 0, manualContainerChanged = false, manualContainerValue = 0, container) => {

        // const item = itemCode || formDataDetail.Item_Code;
        // if (!companyCode || !item) {
        //     console.error("Missing required values:");
        //     return { Amount: 0, NetWt: 0 };
        // }

        const CheckRateper = checkRateperData;
        // console.log("CheckRateper", CheckRateper);

        if (!CheckRateper) return { Amount: 0, Net_weight: 0 };

        // let NetWt = manualNetWtChanged
        //     ? manualNetWtValue
        //     : Quantity * wtpr;

        // if (manualNetWtChanged && manualNetWtValue !== null) {
        //     NetWt = manualNetWtValue; //use manual value
        //     console.log("Manual NetWt used →", NetWt);
        // } else {
        //     NetWt = Quantity * wtpr;  //calculate automatically
        //     console.log("Calculated NetWt →", NetWt);
        // }
        // const roundedNetwt = Math.round(NetWt);


        const Hamali_Rate = (Quantity * Hamali);
        // const Tolai_Rate = Number(((Net_weight * Tolai) / 100).toFixed(2));
        const Tolai_Rate =
            CheckRateper.RatePer === "T"
                ? Number((Quantity * Tolai).toFixed(2))
                : Number(((Net_weight / 100) * Tolai).toFixed(2)); // covers T, K, or anything else


        const Leavy = Number((((Hamali_Rate + Tolai_Rate) * Leavy_Rate) / 100).toFixed(2));

        let Amount =
            CheckRateper.RatePer === "T" || CheckRateper.RatePer === "K"
                ? (Net_weight / 100) * Rate
                : Quantity * Rate;


        const MarketCess = Number(((Amount * Market_Rate) / 100).toFixed(2));
        const DekhRekh = Number(((Amount * Dekrekh_Rate) / 100).toFixed(2));

        let containerAmt;

        if (manualContainerChanged === true) {
            // user typed containerAmt → respect it
            containerAmt = parseFloat(manualContainerValue) || 0;
        } else {
            // auto calculation
            containerAmt = parseFloat(Quantity) * parseFloat(container || 0);
        }


        containerAmt = Number(containerAmt.toFixed(2));
        Amount = Number(Amount.toFixed(2));

        console.log("Container Calculation →", {
            Quantity,
            container: formDataDetail.container,
            containerAmt,
            manualContainerChanged,
        });

        console.log("Leavy Calculation →", {
            Hamali,
            Tolai,
            Leavy,
            Hamali_Rate,
            Tolai_Rate,
            Leavy_Rate,
        });


        return { Amount, Net_weight, MarketCess, DekhRekh, Hamali, Tolai, Hamali_Rate, Tolai_Rate, Leavy, containerAmt };
    };


    const checkLoadingGst = async (company_code, System_Code) => {

        try {
            const { data } = await axios.get(
                `${process.env.REACT_APP_API}/ChekRateper`,
                {
                    params: {
                        Company_Code: company_code,
                        System_Code: System_Code,
                    },
                }
            );

            return data[0];
        } catch (error) {
            console.error("Couldn't able to match GST State Code:", error);
            return error;
        }
    };



    // const handleChangeDetail = async (event) => {
    //     debugger
    //     const { name, value } = event.target;

    //     const updatedDetail = {
    //         ...formDataDetail,
    //         [name]: value,
    //     };

    //     // if (name === "ExtraSut") {

    //     //     const extraSut = Number(value || 0);

    //     //     setFormDataDetail(prev => {

    //     //         const GrossWt = Number(prev.GrossWt || 0);
    //     //         const BagSut = Number(prev.BagSut || 0);

    //     //         const NetWt = Number((GrossWt - BagSut - extraSut).toFixed(2));

    //     //         return {
    //     //             ...prev,
    //     //             ExtraSut: extraSut,
    //     //             Net_weight: NetWt,
    //     //             isNetWeightManuallyChanged: true
    //     //         };
    //     //     });

    //     //     return;
    //     // }

    //     if (name === "ExtraSut") {

    //         const extraSut = Number(value || 0);

    //         const GrossWt = Number(formDataDetail.GrossWt || 0);
    //         const BagSut = Number(formDataDetail.BagSut || 0);

    //         const NetWt = Number((GrossWt - BagSut - extraSut).toFixed(2));


    //         const calc = await calculateDetails(
    //             formDataDetail.Quantity,
    //             formDataDetail.Rate,
    //             NetWt,
    //             formDataDetail.Market_Rate,
    //             formDataDetail.Dekrekh_Rate,
    //             formDataDetail.Hamali,
    //             formDataDetail.Tolai,
    //             formDataDetail.Leavy_Rate,
    //             true,
    //             NetWt,
    //             formDataDetail.isContainerManuallyChanged,
    //             formDataDetail.containerAmt,
    //             formDataDetail.container
    //         );

    //         setFormDataDetail(prev => ({
    //             ...prev,
    //             ExtraSut: extraSut,
    //             Net_weight: NetWt,
    //             Amount: calc.Amount,
    //             Market_Cess: calc.MarketCess,
    //             Dekrekh: calc.DekhRekh,
    //             Hamali: calc.Hamali,
    //             Tolai: calc.Tolai,
    //             hamalical: calc.Hamali_Rate,
    //             Tolaical: calc.Tolai_Rate,
    //             leavy: calc.Leavy,
    //             containerAmt: calc.containerAmt,
    //             isNetWeightManuallyChanged: true
    //         }));

    //         return;
    //     }



    //     // if (name === "additionNetWt") {

    //     //     const parts = (value || "")
    //     //         .split("+")
    //     //         .map(v => v.trim())
    //     //         .filter(v => v !== "" && !isNaN(v));

    //     //     const sum = parts.reduce((acc, val) => acc + parseFloat(val), 0);

    //     //     const GrossWt = Number(sum.toFixed(2));
    //     //     const BagSut = Number((parts.length * 0.5).toFixed(2));

    //     //     setFormDataDetail(prev => {

    //     //         const extraSut = Number(prev.ExtraSut || 0);

    //     //         const NetWt = Number((sum - BagSut - extraSut).toFixed(2));

    //     //         return {
    //     //             ...prev,
    //     //             additionNetWt: value,
    //     //             GrossWt,
    //     //             BagSut,
    //     //             ExtraSut: extraSut,
    //     //             Net_weight: NetWt,
    //     //             isNetWeightManuallyChanged: true
    //     //         };
    //     //     });

    //     //     return;
    //     // }

    //     if (name === "additionNetWt") {

    //         const parts = (value || "")
    //             .split("+")
    //             .map(v => v.trim())
    //             .filter(v => v !== "" && !isNaN(v));

    //         const sum = parts.reduce((acc, val) => acc + parseFloat(val), 0);

    //         const GrossWt = Number(sum.toFixed(2));
    //         const BagSut = Number((parts.length * 0.5).toFixed(2));
    //         const extraSut = Number(formDataDetail.ExtraSut || 0);

    //         const NetWt = Number((sum - BagSut - extraSut).toFixed(2));

    //         // Recalculate amount immediately
    //         const calc = await calculateDetails(
    //             formDataDetail.Quantity,
    //             formDataDetail.Rate,
    //             NetWt,
    //             formDataDetail.Market_Rate,
    //             formDataDetail.Dekrekh_Rate,
    //             formDataDetail.Hamali,
    //             formDataDetail.Tolai,
    //             formDataDetail.Leavy_Rate,
    //             true,
    //             NetWt,
    //             formDataDetail.isContainerManuallyChanged,
    //             formDataDetail.containerAmt,
    //             formDataDetail.container
    //         );

    //         setFormDataDetail(prev => ({
    //             ...prev,
    //             additionNetWt: value,
    //             GrossWt,
    //             BagSut,
    //             ExtraSut: extraSut,
    //             Net_weight: NetWt,
    //             Amount: calc.Amount,
    //             Market_Cess: calc.MarketCess,
    //             Dekrekh: calc.DekhRekh,
    //             Hamali: calc.Hamali,
    //             Tolai: calc.Tolai,
    //             leavy: calc.Leavy,
    //             hamalical: calc.Hamali_Rate,
    //             Tolaical: calc.Tolai_Rate,
    //             containerAmt: calc.containerAmt,
    //             isNetWeightManuallyChanged: true
    //         }));

    //         return;
    //     }



    //     const Market_Rate = !isNaN(parseFloat(updatedDetail.Market_Rate))
    //         ? parseFloat(updatedDetail.Market_Rate)
    //         : parseFloat(selectedFetchedDetail?.Market_Cess) || 0;

    //     const Dekrekh_Rate = !isNaN(parseFloat(updatedDetail.Dekrekh_Rate))
    //         ? parseFloat(updatedDetail.Dekrekh_Rate)
    //         : parseFloat(selectedFetchedDetail?.Dekrekh) || 0;

    //     const hamali =
    //         !isNaN(parseFloat(updatedDetail.Hamali))
    //             ? parseFloat(updatedDetail.Hamali)
    //             // : parseFloat(selectedFetchedDetail?.Hamali_rate) || 0;
    //             : getEffectiveHamaliRate(selectedFetchedDetail);

    //     const tolai =
    //         !isNaN(parseFloat(updatedDetail.Tolai))
    //             ? parseFloat(updatedDetail.Tolai)
    //             // : parseFloat(selectedFetchedDetail?.Tolai_rate) || 0;
    //             : getEffectiveTolaiRate(selectedFetchedDetail);

    //     const Leavy_Rate =
    //         !isNaN(parseFloat(updatedDetail.Leavy_Rate))
    //             ? parseFloat(updatedDetail.Leavy_Rate)
    //             : parseFloat(selectedFetchedDetail?.Levi_rate) || 0;

    //     const contain =
    //         !isNaN(parseFloat(updatedDetail.container))
    //             ? parseFloat(updatedDetail.container)
    //             : parseFloat(selectedFetchedDetail?.Container) || 0;

    //     console.log("selectedFetchedDetail", selectedFetchedDetail)

    //     const { Quantity, Rate, Net_weight } = updatedDetail;

    //     console.log("updatedDetail", Quantity)

    //     const {
    //         Amount,
    //         MarketCess,
    //         DekhRekh,
    //         Hamali,
    //         Tolai,
    //         Hamali_Rate,
    //         Tolai_Rate,
    //         Leavy,
    //         containerAmt,
    //     } = await calculateDetails(
    //         Quantity,
    //         Rate,
    //         Net_weight,
    //         Market_Rate,
    //         Dekrekh_Rate,
    //         hamali,
    //         tolai,
    //         Leavy_Rate,
    //         formDataDetail.isNetWeightManuallyChanged,
    //         formDataDetail.Net_weight,
    //         formDataDetail.isContainerManuallyChanged,
    //         updatedDetail.containerAmt,
    //         contain
    //     );

    //     setFormDataDetail((prev) => {
    //         let isNetWeightManuallyChanged = prev.isNetWeightManuallyChanged;
    //         let isContainerManuallyChanged = prev.isContainerManuallyChanged;

    //         // Net weight logic
    //         if (name === "Net_weight") isNetWeightManuallyChanged = true;
    //         if (name === "Quantity")
    //             isNetWeightManuallyChanged = false;

    //         // Container logic (CORRECT)
    //         // User manually typed containerAmt → lock it
    //         if (name === "containerAmt") {
    //             isContainerManuallyChanged = true;
    //         }

    //         // If user edits container OR Quantity → auto recalc
    //         if (name === "container" || name === "Quantity") {
    //             isContainerManuallyChanged = false;
    //         }


    //         return {
    //             ...prev,
    //             [name]: value,
    //             Amount,
    //             Net_weight: updatedDetail.Net_weight,
    //             Market_Cess: MarketCess,
    //             Dekrekh: DekhRekh,
    //             Hamali,
    //             Tolai,
    //             hamalical: Hamali_Rate,
    //             Tolaical: Tolai_Rate,
    //             leavy: Leavy,
    //             container: contain,
    //             containerAmt,
    //             Market_Rate,
    //             Dekrekh_Rate,
    //             Leavy_Rate,
    //             isNetWeightManuallyChanged,
    //             isContainerManuallyChanged,
    //         };
    //     });
    // };
    const handleChangeDetail = async (event) => {

        const { name, value } = event.target;

        const updatedDetail = {
            ...formDataDetail,
            [name]: value,
        };

        if (name === "ExtraSut") {

            const extraSut = Number(value || 0);

            const GrossWt = Number(formDataDetail.GrossWt || 0);
            const BagSut = Number(formDataDetail.BagSut || 0);

            const NetWt = Number((GrossWt - BagSut - extraSut).toFixed(2));

            //  ExtraSut changes the net-weight basis → refresh rates too
            const hamaliForCalc = selectedFetchedDetail
                ? getEffectiveHamaliRate(selectedFetchedDetail)
                : formDataDetail.Hamali;
            const tolaiForCalc = selectedFetchedDetail
                ? getEffectiveTolaiRate(selectedFetchedDetail)
                : formDataDetail.Tolai;

            const calc = await calculateDetails(
                formDataDetail.Quantity,
                formDataDetail.Rate,
                NetWt,
                formDataDetail.Market_Rate,
                formDataDetail.Dekrekh_Rate,
                hamaliForCalc,
                tolaiForCalc,
                formDataDetail.Leavy_Rate,
                true,
                NetWt,
                formDataDetail.isContainerManuallyChanged,
                formDataDetail.containerAmt,
                formDataDetail.container
            );

            setFormDataDetail(prev => ({
                ...prev,
                ExtraSut: extraSut,
                Net_weight: NetWt,
                Amount: calc.Amount,
                Market_Cess: calc.MarketCess,
                Dekrekh: calc.DekhRekh,
                Hamali: calc.Hamali,
                Tolai: calc.Tolai,
                hamalical: calc.Hamali_Rate,
                Tolaical: calc.Tolai_Rate,
                leavy: calc.Leavy,
                containerAmt: calc.containerAmt,
                isNetWeightManuallyChanged: true
            }));

            return;
        }

        if (name === "additionNetWt") {

            const parts = (value || "")
                .split("+")
                .map(v => v.trim())
                .filter(v => v !== "" && !isNaN(v));

            const sum = parts.reduce((acc, val) => acc + parseFloat(val), 0);

            const GrossWt = Number(sum.toFixed(2));
            const BagSut = Number((parts.length * 0.5).toFixed(2));
            const extraSut = Number(formDataDetail.ExtraSut || 0);

            const NetWt = Number((sum - BagSut - extraSut).toFixed(2));

            //  additionNetWt changes the net-weight basis → refresh rates too
            const hamaliForCalc = selectedFetchedDetail
                ? getEffectiveHamaliRate(selectedFetchedDetail)
                : formDataDetail.Hamali;
            const tolaiForCalc = selectedFetchedDetail
                ? getEffectiveTolaiRate(selectedFetchedDetail)
                : formDataDetail.Tolai;

            // Recalculate amount immediately
            const calc = await calculateDetails(
                formDataDetail.Quantity,
                formDataDetail.Rate,
                NetWt,
                formDataDetail.Market_Rate,
                formDataDetail.Dekrekh_Rate,
                hamaliForCalc,
                tolaiForCalc,
                formDataDetail.Leavy_Rate,
                true,
                NetWt,
                formDataDetail.isContainerManuallyChanged,
                formDataDetail.containerAmt,
                formDataDetail.container
            );

            setFormDataDetail(prev => ({
                ...prev,
                additionNetWt: value,
                GrossWt,
                BagSut,
                ExtraSut: extraSut,
                Net_weight: NetWt,
                Amount: calc.Amount,
                Market_Cess: calc.MarketCess,
                Dekrekh: calc.DekhRekh,
                Hamali: calc.Hamali,
                Tolai: calc.Tolai,
                leavy: calc.Leavy,
                hamalical: calc.Hamali_Rate,
                Tolaical: calc.Tolai_Rate,
                containerAmt: calc.containerAmt,
                isNetWeightManuallyChanged: true
            }));

            return;
        }

        const Market_Rate = !isNaN(parseFloat(updatedDetail.Market_Rate))
            ? parseFloat(updatedDetail.Market_Rate)
            : parseFloat(selectedFetchedDetail?.Market_Cess) || 0;

        const Dekrekh_Rate = !isNaN(parseFloat(updatedDetail.Dekrekh_Rate))
            ? parseFloat(updatedDetail.Dekrekh_Rate)
            : parseFloat(selectedFetchedDetail?.Dekrekh) || 0;

        //  Force refresh Hamali/Tolai/Leavy_Rate from source whenever a
        //  weight/quantity-basis field changes (same trigger list as
        //  handleKeyDownCalculations, kept in sync)
        const shouldRefreshRates = RATE_REFRESH_FIELDS.includes(name) && !!selectedFetchedDetail;

        const hamali = shouldRefreshRates
            ? getEffectiveHamaliRate(selectedFetchedDetail)
            : (!isNaN(parseFloat(updatedDetail.Hamali))
                ? parseFloat(updatedDetail.Hamali)
                : getEffectiveHamaliRate(selectedFetchedDetail));

        const tolai = shouldRefreshRates
            ? getEffectiveTolaiRate(selectedFetchedDetail)
            : (!isNaN(parseFloat(updatedDetail.Tolai))
                ? parseFloat(updatedDetail.Tolai)
                : getEffectiveTolaiRate(selectedFetchedDetail));

        const Leavy_Rate = shouldRefreshRates
            ? (parseFloat(selectedFetchedDetail?.Levi_rate) || 0)
            : (!isNaN(parseFloat(updatedDetail.Leavy_Rate))
                ? parseFloat(updatedDetail.Leavy_Rate)
                : (parseFloat(selectedFetchedDetail?.Levi_rate) || 0));

        const contain =
            !isNaN(parseFloat(updatedDetail.container))
                ? parseFloat(updatedDetail.container)
                : parseFloat(selectedFetchedDetail?.Container) || 0;

        console.log("selectedFetchedDetail", selectedFetchedDetail)

        const { Quantity, Rate, Net_weight } = updatedDetail;

        console.log("updatedDetail", Quantity)

        const {
            Amount,
            MarketCess,
            DekhRekh,
            Hamali,
            Tolai,
            Hamali_Rate,
            Tolai_Rate,
            Leavy,
            containerAmt,
        } = await calculateDetails(
            Quantity,
            Rate,
            Net_weight,
            Market_Rate,
            Dekrekh_Rate,
            hamali,
            tolai,
            Leavy_Rate,
            formDataDetail.isNetWeightManuallyChanged,
            formDataDetail.Net_weight,
            formDataDetail.isContainerManuallyChanged,
            updatedDetail.containerAmt,
            contain
        );

        setFormDataDetail((prev) => {
            let isNetWeightManuallyChanged = prev.isNetWeightManuallyChanged;
            let isContainerManuallyChanged = prev.isContainerManuallyChanged;

            // Net weight logic
            if (name === "Net_weight") isNetWeightManuallyChanged = true;
            if (name === "Quantity")
                isNetWeightManuallyChanged = false;

            // Container logic (CORRECT)
            // User manually typed containerAmt → lock it
            if (name === "containerAmt") {
                isContainerManuallyChanged = true;
            }

            // If user edits container OR Quantity → auto recalc
            if (name === "container" || name === "Quantity") {
                isContainerManuallyChanged = false;
            }

            return {
                ...prev,
                [name]: value,
                Amount,
                Net_weight: updatedDetail.Net_weight,
                Market_Cess: MarketCess,
                Dekrekh: DekhRekh,
                Hamali,
                Tolai,
                hamalical: Hamali_Rate,
                Tolaical: Tolai_Rate,
                leavy: Leavy,
                container: contain,
                containerAmt,
                Market_Rate,
                Dekrekh_Rate,
                Leavy_Rate,
                isNetWeightManuallyChanged,
                isContainerManuallyChanged,
            };
        });
    };


    const addUser = async () => {

        const rateCheck = await checkRate(formData.ic || itemCodeAccoid);
        setTimeout(() => {
            addButtonRef.current.focus();
        }, 500)

        if (itemCode === "") {
            Swal.fire({
                icon: "warning",
                text: "Please Select Item.",
                confirmButtonColor: "#d33",
            });
            return false;
        }
        // if (formDataDetail.wtpr === "" || 0) {
        //     Swal.fire({
        //         icon: "warning",
        //         text: "Please Fill Wt/Per.",
        //         confirmButtonColor: "#d33",
        //     });
        //     return false;
        // }

        // if (rateCheck) {
        //     const { minRate, maxRate, minWeight, maxWeight } = rateCheck;

        //     const currentSaleRate = parseFloat(formDataDetail.Rate);
        //     if (
        //         !isNaN(currentSaleRate) &&
        //         (currentSaleRate < minRate || currentSaleRate > maxRate)
        //     ) {
        //         return showAlert(
        //             "Invalid Rate",
        //             `Sale Rate must be between ${minRate} and ${maxRate}.`
        //         );
        //     }
        // }

        if (rateCheck) {
            const { minRate, maxRate, minWeight, maxWeight } = rateCheck;

            // Rate validation
            const currentSaleRate = parseFloat(formDataDetail.Rate);
            if (
                !isNaN(currentSaleRate) &&
                minRate !== null &&
                maxRate !== null &&
                (currentSaleRate < minRate || currentSaleRate > maxRate)
            ) {
                return showAlert(
                    "Invalid Rate",
                    `Sale Rate must be between ${minRate} and ${maxRate}.`
                );
            }

            // Weight validation (only if min/max weight exist)
            const currentSaleWeight = parseFloat(formDataDetail.Net_weight);
            if (
                !isNaN(currentSaleWeight) &&
                minWeight !== null &&
                maxWeight !== null &&
                (currentSaleWeight < minWeight || currentSaleWeight > maxWeight)
            ) {
                return showAlert(
                    "Invalid Weight",
                    `Sale Weight must be between ${minWeight} and ${maxWeight}.`
                );
            }
        }

        const maxDetailId =
            users.length > 0
                ? Math.max(...users.map((user) => user.detail_id)) + 1
                : 1;
        const id = users.length > 0 ? Math.max(...users.map(u => u.id)) + 1 : 1;

        const maxSrNo =
            users.length > 0
                ? Math.max(...users.map(u => Number(u.SrNo ?? 0)))
                : 0;

        const newSrNo =
            formDataDetail.SrNo && formDataDetail.SrNo > 0
                ? formDataDetail.SrNo
                : maxSrNo + 1;
        // update counter so next record continues correctly
        setSrNoCounter(newSrNo);

        setSrNoMap(prev => ({
            ...prev,
            [id]: newSrNo
        }));

        const newUser = {
            id: users.length > 0 ? Math.max(...users.map((user) => user.id)) + 1 : 1,
            Item_Code: itemCode,
            item_Name: item_Name,
            ic: itemCodeAccoid,
            Linecode: line_code,
            brand_name: line_name,
            ...formDataDetail,
            SrNo: newSrNo,
            detail_id: maxDetailId,
            rowaction: "add",
        };

        const updatedUsers = [...users, newUser];
        setSelectedFetchedDetail(null);
        setUsers(updatedUsers);


        const total = calculateTotals(updatedUsers);
        const subtotal = total.totalamt;
        const netquat = total.totalQty;
        const netWt = parseFloat(Number(total.totalNetwt).toFixed(2));
        const markt = total.totalMrktcess;
        const dekh = total.totaldekhRek;
        const levi = total.totalleavy;
        const contaner = total.totalcont;
        const hamale = total.totalhamali;
        const tolae = total.totaltolai;
        let updatedFormData = {
            ...formData,
            // NETQNTL: netQuantal,
            SubTotal: subtotal,
            Net_quantity: netquat,
            Net_weight: netWt,
            MarketCess: markt,
            DekhRekh: dekh,
            Leavy: levi,
            Container: contaner,
            HamaliAmt: hamale,
            TolaiAmt: tolae,
        };

        updatedFormData = await calculateDependentValues(
            "SubTotal",
            updatedFormData.SubTotal,
            updatedFormData
        );


        setFormData(updatedFormData);
        closePopup();

        //  RESET ADDITION FIELD
        setNetWeightExpression("");

        setFormDataDetail(prev => ({
            ...prev,
            Net_weight: 0,
            isNetWeightManuallyChanged: false
        }));

    };

    //TDS Amount Calculation.
    const AmountCalculation = async (name, input, formData) => {
        formData = {
            ...formData,
            TCS_Rate: 0.00,
            TDS_Rate: 0.00,
            TDS_Amt: 0.00,
            TCS_Amt: 0.00
        }

        let updatedFormData = { ...formData, [name]: input };
        let Ac_Code = input;
        const updateApiUrl = `${API_URL}/getAmountcalculationDataForOutword?CompanyCode=${companyCode}&Ac_Code=${Ac_Code}&Year_Code=${Year_Code}`;

        const response = await axios.get(updateApiUrl);
        const details = response.data;
        let balancelimit = details['Balancelimt']
        let TDSApplicable = details['SaleTDSApplicable_Data']
        let SBAmt = 0.00;
        let SBBalAmt = 0.00;
        // let PSRate = parseFloat(updatedFormData.PurchaseRate) || 0.00;
        let SBAmountf = 0.00;
        let SBAmount = 0.00;
        let SaleTDSRate = details['SaleTDSRate']
        let TCSRate = TCSApplicable === 'Y' ? details['TCSRate'] : 0.00;
        SBBalAmt = formData.SubTotal;
        SBAmountf = details['SBAmt']
        if (SBAmountf == 0) {
            SBAmountf = 0.00
        }
        SBAmount = SBAmountf + SBBalAmt;

        if (SBAmount >= balancelimit) {
            if (TDSApplicable === 'Y') {
                updatedFormData.TDS_Rate = SaleTDSRate;
                const tdsAmount = ((SBBalAmt * SaleTDSRate) / 100).toFixed(2);
                updatedFormData.TDS_Amt = tdsAmount;
            }
            else {
                updatedFormData.TDS_Rate = 0.00;
            }
        }
        else {
            updatedFormData.TDS_Rate = 0.00;
        }


        setFormData((prevFormData) => ({
            ...prevFormData,
            ...updatedFormData

        }));
        return updatedFormData;
    }

    const updateUser = async () => {
        setTimeout(() => {
            addButtonRef.current.focus();
        }, 500)
        const rateCheck = await checkRate(formData.ic || itemCodeAccoid);

        const maxSrNo =
            users.length > 0
                ? Math.max(...users.map(u => Number(u.SrNo ?? 0)))
                : 0;
        const updatedUsers = users.map((user) => {
            if (user.id === selectedUser.id) {
                const updatedRowaction =
                    user.rowaction === "Normal" ? "update" : user.rowaction;

                const isHelpChanged =
                    user.Item_Code !== itemCode ||
                    user.ic !== itemCodeAccoid;


                // if (rateCheck) {
                //     const { minRate, maxRate } = rateCheck;

                //     const currentSaleRate = parseFloat(formDataDetail.Rate);
                //     if (
                //         !isNaN(currentSaleRate) &&
                //         (currentSaleRate < minRate || currentSaleRate > maxRate)
                //     ) {
                //         return showAlert(
                //             "Invalid Rate",
                //             `Sale Rate must be between ${minRate} and ${maxRate}.`
                //         );
                //     }
                // }


                if (rateCheck) {
                    const { minRate, maxRate, minWeight, maxWeight } = rateCheck;

                    // Rate validation
                    const currentSaleRate = parseFloat(formDataDetail.Rate);
                    if (
                        !isNaN(currentSaleRate) &&
                        minRate !== null &&
                        maxRate !== null &&
                        (currentSaleRate < minRate || currentSaleRate > maxRate)
                    ) {
                        return showAlert(
                            "Invalid Rate",
                            `Sale Rate must be between ${minRate} and ${maxRate}.`
                        );
                    }

                    // Weight validation (only if min/max weight exist)
                    const currentSaleWeight = parseFloat(formDataDetail.Net_weight);
                    if (
                        !isNaN(currentSaleWeight) &&
                        minWeight !== null &&
                        maxWeight !== null &&
                        (currentSaleWeight < minWeight || currentSaleWeight > maxWeight)
                    ) {
                        return showAlert(
                            "Invalid Weight",
                            `Sale Weight must be between ${minWeight} and ${maxWeight}.`
                        );
                    }
                }

                // Keep old Market/Dekrekh rates if help didn’t change
                const Market_Rate = isHelpChanged
                    ? (selectedFetchedDetail?.Market_Cess || 0)
                    : (user.Market_Rate || formDataDetail.Market_Rate || 0);
                const Dekrekh_Rate = isHelpChanged
                    ? (selectedFetchedDetail?.Dekrekh || 0)
                    : (user.Dekrekh_Rate || formDataDetail.Dekrekh_Rate || 0);
                // const Hamali = isHelpChanged
                //     ? (selectedFetchedDetail?.Hamali_rate || 0)
                //     : (user.Hamali || formDataDetail.Hamali || 0);
                const Hamali = isHelpChanged
                    ? getEffectiveHamaliRate(selectedFetchedDetail)
                    : (!isNaN(parseFloat(formDataDetail.Hamali))
                        ? parseFloat(formDataDetail.Hamali)
                        : (parseFloat(user.Hamali) || 0));
                const Tolai = isHelpChanged
                    ? getEffectiveTolaiRate(selectedFetchedDetail)
                    : (!isNaN(parseFloat(formDataDetail.Tolai))
                        ? parseFloat(formDataDetail.Tolai)
                        : (parseFloat(user.Tolai) || 0));
                const Leavy_Rate = isHelpChanged
                    ? (selectedFetchedDetail?.Levi_rate || 0)
                    : (user.Leavy_Rate || formDataDetail.Leavy_Rate || 0);
                const container = isHelpChanged
                    ? (selectedFetchedDetail?.Container || 0)
                    : (user.container || formDataDetail.container || 0);

                const rateSource = isHelpChanged
                    ? (selectedFetchedDetail || null)   // help changed → new source picked via proformaFetchedData
                    : (user.rateSource || selectedFetchedDetail || null);

                let updatedSrNo = user.SrNo;

                if (!updatedSrNo || updatedSrNo === 0) {
                    updatedSrNo = maxSrNo + 1;
                }
                return {
                    ...user,
                    Linecode: line_code,
                    brand_name: line_name,
                    Item_Code: itemCode,
                    item_Name: item_Name,
                    ic: itemCodeAccoid,
                    Awak_No: Awakcode,
                    Awakid: AwakId,
                    additionNetWt: formDataDetail.additionNetWt || netWeightExpression,
                    GrossWt: formDataDetail.GrossWt,
                    tolaidarName: formDataDetail.tolaidarName,
                    BagSut: formDataDetail.BagSut,
                    ExtraSut: formDataDetail.ExtraSut,
                    wtpr: formDataDetail.wtpr,
                    Net_weight: formDataDetail.Net_weight,
                    Quantity: formDataDetail.Quantity,
                    awakdetailId: formDataDetail.awakdetailId,
                    Rate: formDataDetail.Rate,
                    Amount: formDataDetail.Amount,
                    Market_Cess: formDataDetail.Market_Cess,
                    Dekrekh: formDataDetail.Dekrekh,
                    leavy: formDataDetail.leavy,
                    hamalical: formDataDetail.hamalical,
                    Tolaical: formDataDetail.Tolaical,
                    container,
                    containerAmt: formDataDetail.containerAmt,
                    Market_Rate,
                    Dekrekh_Rate,
                    Hamali,
                    Leavy_Rate,
                    Tolai,
                    Patti_No: formDataDetail.Patti_No,
                    Patti_Id: formDataDetail.Patti_Id,
                    Farmer_Code: formDataDetail.Farmer_Code,
                    fc: formDataDetail.fc,
                    Tran_Type: formDataDetail.Tran_Type,
                    awkid: formDataDetail.awkid,
                    KattaPatti: formDataDetail.KattaPatti,
                    detail_id: user.detail_id,
                    SrNo: updatedSrNo,
                    rateSource,
                    rowaction: updatedRowaction,
                };
            } else {
                return user;
            }
        });

        setUsers(updatedUsers);

        const total = calculateTotals(updatedUsers);
        const subtotal = total.totalamt;
        const netquat = total.totalQty;
        const netWt = parseFloat(Number(total.totalNetwt).toFixed(2));
        const markt = total.totalMrktcess;
        const dekh = total.totaldekhRek;
        const levi = total.totalleavy;
        const contaner = total.totalcont;
        const hamale = total.totalhamali;
        const tolae = total.totaltolai;
        let updatedFormData = {
            ...formData,
            // NETQNTL: netQuantal,
            SubTotal: subtotal,
            Net_quantity: netquat,
            Net_weight: netWt,
            MarketCess: markt,
            DekhRekh: dekh,
            Leavy: levi,
            Container: contaner,
            HamaliAmt: hamale,
            TolaiAmt: tolae,

        };

        updatedFormData = await calculateDependentValues(
            "SubTotal",
            updatedFormData.SubTotal,
            updatedFormData
        );


        setFormData(updatedFormData);
        closePopup();
    };

    const deleteModeHandler = async (user) => {
        try {

            const awakNo = user.Awak_No;
            const awakId = user.awakdetailId;

            if (!awakNo || awakNo <= 0) {
                Swal.fire({
                    icon: "error",
                    title: "Cannot Delete",
                    text: "Awak No is not valid. Cannot perform deletion.",
                    confirmButtonColor: "#d33",
                });
                return;
            }

            // Check if this Awak_No is already used in GulSaleBilldetail
            const usage = await checkAwakNoUsage(awakId);

            if (usage.isUsed) {
                Swal.fire({
                    icon: "error",
                    title: "Cannot Delete",
                    text: "This Awak No is already used in Gul Sale Bill Detail. You cannot delete it.",
                    confirmButtonColor: "#d33",
                });
                return;
            }

            let updatedUsers;
            if (isEditMode && user.rowaction === "add") {
                setDeleteMode(true);
                setSelectedUser(user);
                updatedUsers = users.map((u) =>
                    u.id === user.id ? { ...u, rowaction: "DNU" } : u
                );
            } else if (isEditMode) {
                setDeleteMode(true);
                setSelectedUser(user);
                updatedUsers = users.map((u) =>
                    u.id === user.id ? { ...u, rowaction: "delete" } : u
                );
            } else {
                setDeleteMode(true);
                setSelectedUser(user);
                updatedUsers = users.map((u) =>
                    u.id === user.id ? { ...u, rowaction: "DNU" } : u
                );
            }

            setUsers(updatedUsers);
            setSelectedUser({});

            const total = calculateTotals(updatedUsers);
            const subtotal = total.totalamt;
            const netquat = total.totalQty;
            const netWt = parseFloat(Number(total.totalNetwt).toFixed(2));
            const markt = total.totalMrktcess;
            const dekh = total.totaldekhRek;
            const levi = total.totalleavy;
            const contaner = total.totalcont;
            const hamale = total.totalhamali;
            const tolae = total.totaltolai;
            let updatedFormData = {
                ...formData,
                // NETQNTL: netQuantal,
                SubTotal: subtotal,
                Net_quantity: netquat,
                Net_weight: netWt,
                MarketCess: markt,
                DekhRekh: dekh,
                Leavy: levi,
                Container: contaner,
                HamaliAmt: hamale,
                TolaiAmt: tolae,
            };

            updatedFormData = await calculateDependentValues(
                "SubTotal",
                updatedFormData.SubTotal,
                updatedFormData
            );

            setFormData(updatedFormData);
        } catch (error) {
            console.error("Error in deleteModeHandler:", error);
            await Swal.fire({
                title: "Error",
                text: "An unexpected error occurred while deleting the Sale Bill detail.",
                icon: "error",
            });
        }
    };



    const openDelete = async (user) => {
        setDeleteMode(true);
        setSelectedUser(user);
        let updatedUsers;
        if (isEditMode && user.rowaction === "delete") {
            updatedUsers = users.map((u) =>
                u.id === user.id ? { ...u, rowaction: "Normal" } : u
            );
        } else {
            updatedUsers = users.map((u) =>
                u.id === user.id ? { ...u, rowaction: "add" } : u
            );
        }
        setUsers(updatedUsers);
        setSelectedUser({});

        const total = calculateTotals(updatedUsers);
        const subtotal = total.totalamt;
        const netquat = total.totalQty;
        const netWt = parseFloat(Number(total.totalNetwt).toFixed(2));
        const markt = total.totalMrktcess;
        const dekh = total.totaldekhRek;
        const levi = total.totalleavy;
        const contaner = total.totalcont;
        const hamale = total.totalhamali;
        const tolae = total.totaltolai;
        let updatedFormData = {
            ...formData,
            // NETQNTL: netQuantal,
            SubTotal: subtotal,
            Net_quantity: netquat,
            Net_weight: netWt,
            MarketCess: markt,
            DekhRekh: dekh,
            Leavy: levi,
            Container: contaner,
            HamaliAmt: hamale,
            TolaiAmt: tolae,
        };



        updatedFormData = await calculateDependentValues(
            "SubTotal",
            updatedFormData.SubTotal,
            updatedFormData
        );


        setFormData(updatedFormData);
    };

    const openPopup = (mode) => {
        setPopupMode(mode);
        setShowPopup(true);

        if (mode === "add") {
            clearForm();

            const nextSrNo =
                users.length > 0
                    ? Math.max(...users.map(u => Number(u.SrNo ?? 0))) + 1
                    : 1;

            setFormDataDetail(prev => ({
                ...prev,
                SrNo: nextSrNo
            }));
        }
    };
    const closePopup = () => {
        setShowPopup(false);
        setSelectedUser({});
        clearForm();
    };

    const clearForm = () => {
        setFormDataDetail({
            Quantity: 0.00,
            wtpr: 0.0,
            Net_weight: 0.0,
            Rate: 0.0,
            Amount: 0.0,
            additionNetWt: "",
            GrossWt: 0.00,
            tolaidarName: "",
            BagSut: 0.00,
            ExtraSut: 0.00,
            KattaPatti: 0,
            detail_id: 1,

        });
        setItemCode("");
        setItemName("");
        setLineCode("");
        setLineName("");
        setAwakCode("");
        setAwakId("");
    };


    const fetchAwakRateSource = async (Id, itemCode) => {

        if (!Id) return null;
        try {
            const response = await axios.get(
                `${API_URL}/getdata-AwakEntryByidForhelp`,
                {
                    params: {
                        Company_Code: companyCode,
                        Year_Code: Year_Code,
                        Id: Id,
                    },
                }
            );
            const detailsArray = Array.isArray(response.data?.all_data)
                ? response.data.all_data
                : [];

            if (detailsArray.length === 0) return null;

            //  Don't blindly take [0] — if the Awak doc has multiple
            // items, match explicitly instead of trusting ordering.
            const exactMatch =
                detailsArray.find(d => Number(d.Id) === Number(Id)) ||
                (itemCode
                    ? detailsArray.find(d => String(d.Item_Code) === String(itemCode))
                    : null);

            return exactMatch || detailsArray[0];
        } catch (error) {
            console.error("Error fetching Awak rate source:", error);
            return null;
        }
    };

    const editUser = async (user) => {


        const hasPatti =
            (user.Patti_No && Number(user.Patti_No) > 0) ||
            (user.Patti_Id && Number(user.Patti_Id) > 0);

        if (hasPatti) {
            Swal.fire({
                icon: "error",
                title: "Cannot Edit",
                text: `This detail record already has a Patti entry (Patti No: ${user.Patti_No || "-"}). You cannot edit it.`,
                confirmButtonColor: "#d33",
            });
            return;
        }
        // const isUsed =  checkGulSalebillUsage(formData.doc_no);

        // if (isUsed) {
        //     Swal.fire({
        //         icon: "error",
        //         title: "Cannot Edit",
        //         text: "This Doc No is already used in Service Bill. You cannot edit it.",
        //         confirmButtonColor: "#d33",
        //     });
        //     return;
        // }

        const id = user.salebilldetailId;

        // let newSrNo;

        // // If ID exists
        // if (id) {
        //     newSrNo = srNoMap[id];

        //     if (!newSrNo) {
        //         newSrNo = srNoCounter + 1;

        //         setSrNoCounter(prev => prev + 1);

        //         setSrNoMap(prev => ({
        //             ...prev,
        //             [id]: newSrNo
        //         }));
        //     }
        // }
        // // If ID does not exist
        // else {
        //     newSrNo = srNoCounter + 1;
        //     setSrNoCounter(prev => prev + 1);
        // }
        setSelectedUser(user);
        setItemCode(user.Item_Code);
        setItemName(user.item_Name);
        setLineCode(user.Linecode);
        setLineName(user.brand_name);
        setAwakCode(user.Awak_No);
        setAwakId(user.Awak_Id);
        setItemCodeAccoid(user.ic);
        setFormDataDetail({
            Net_weight: user.Net_weight || 0.0,
            Quantity: user.Quantity || 0.00,
            wtpr: user.wtpr || 0.0,
            Rate: user.Rate || 0.0,
            Amount: user.Amount || 0.0,
            Awak_No: user.Awak_No || 0.0,
            Awak_Id: user.Awak_Id || 0.0,
            Market_Cess: user.Market_Cess || 0.0,
            Dekrekh: user.Dekrekh || 0.0,
            leavy: user.leavy || 0.0,
            hamalical: user.hamalical || 0.00,
            Tolaical: user.Tolaical || 0.00,
            container: user.container || 0.0,
            containerAmt: user.containerAmt || 0.0,
            Market_Rate: user.Market_Rate || 0.0,
            Dekrekh_Rate: user.Dekrekh_Rate || 0.0,
            Leavy_Rate: user.Leavy_Rate || 0.0,
            Hamali: user.Hamali || 0.0,
            Tolai: user.Tolai || 0.0,
            Patti_No: user.Patti_No || 0,
            Patti_Id: user.Patti_Id || 0,
            additionNetWt: user.additionNetWt || "",
            GrossWt: user.GrossWt || 0.00,
            tolaidarName: user.tolaidarName || "",
            BagSut: user.BagSut || 0.00,
            ExtraSut: user.ExtraSut || 0.00,
            awakdetailId: user.awakdetailId || 0,
            awkid: user.awkid || 0,
            KattaPatti: user.KattaPatti || 0,
            Farmer_Code: user.Farmer_Code || 0,
            fc: user.fc || 0,
            detail_id: user.detail_id,
            SrNo: user.SrNo && user.SrNo > 0
                ? user.SrNo
                : Math.max(...users.map(u => Number(u.SrNo ?? 0)), 0) + 1
        });
        if (user.rateSource) {
            //  Use the exact record this row was created from — no ambiguity
            setSelectedFetchedDetail(user.rateSource);
        } else {
            //  Fallback for rows loaded from a saved bill (rateSource wasn't persisted)
            // const freshDetail = await fetchAwakRateSource(
            //     user.awakdetailId,
            //     user.Item_Code
            // );
            // setSelectedFetchedDetail(freshDetail);
            const freshDetail = await fetchAwakRateSource(user.awakdetailId, user.Item_Code);
            setSelectedFetchedDetail(freshDetail);
        }
        openPopup("edit");
    };

    const handleItemCode = async (code, accoid, hsn, name) => {
        setItemCode(code);
        setItemName(name);
        setItemCodeAccoid(accoid);

        if (!code || !companyCode) return;

        try {
            const result = await checkLoadingGst(companyCode, code);
            setCheckRateperData(result);   // Store result (RatePer, etc.)
            console.log("RatePer Loaded From Item Selection:", result);
        } catch (err) {
            console.error("Error loading RatePer:", err);
        }
    };

    const handleLineCode = (code, accoid, hsn, name, kgper) => {
        console.log("handleItemCode", kgper)
        setLineCode(code);
        setLineName(name);
        setLineAccoid(accoid);
    };



    const fetchAwakByCustomerCode = async (code) => {

        try {
            const response = await axios.get(
                `${API_URL}/getGulsalebilldata_BycustomerCode`,
                {
                    params: {
                        Company_Code: companyCode,
                        Year_Code,
                        Customer_Code: code,
                    },
                }
            );

            ;

            if (response.status === 200 && response.data?.all_data?.length > 0) {
                console.log("Awak Data:", response.data);

                const awakData = response.data.all_data;
                const firstRow = awakData[0];


                const detailRows = awakData.map((row, index) => ({
                    id: row.AwakdetailId || index + 1,
                    rowaction: "DNU",

                    Item_Code: row.Item_Code || "",
                    item_Name: row.System_Name_E || "",
                    ic: row.ic || "",

                    Linecode: row.Line_code || "",
                    brand_name: row.LineName || "",
                    lc: row.lc || "",

                    Quantity: parseFloat(0),
                    QuantitytoShow: parseFloat(row.balance || 0),
                    Netwt: parseFloat(row.netwt || 0),
                    wtpr: parseFloat(row.wt || 0),
                    Amount: parseFloat(formDataDetail.Amount || 0.00),
                    Rate: parseFloat(row.Salerate || 0),
                    balance: parseFloat(row.balance || 0),
                    Market_Rate: parseFloat(row.Market_Cess || 0.0),
                    Dekrekh_Rate: parseFloat(row.Dekrekh || 0.0),
                    Leavy_Rate: parseFloat(row.Levi_rate || 0.0),
                    Market_Cess: parseFloat(formDataDetail.Market_Cess || 0.0),
                    Dekrekh: parseFloat(formDataDetail.Dekrekh || 0.0),
                    leavy: parseFloat(formDataDetail.leavy || 0.0),
                    // Hamali: parseFloat(row.Hamali_rate || 0.0),
                    Hamali: getEffectiveHamaliRate(row),
                    Tolai: getEffectiveTolaiRate(row),
                    container: parseFloat(row.Container || 0.0),
                    Awak_No: row.Doc_No || 0,
                    Awak_Id: row.Doc_No || 0,
                    awakdetailId: row.Id || 0,

                    Farmer_Code: row.Ac_code || 0,
                    fc: row.ac || 0,
                    Net_weight: 0,
                    hamalical: 0,
                    Tolaical: 0,
                    awkid: row.HeadId || 0,
                    detail_id: index + 1,
                    SrNo: 0,


                    // Readyforsale: row.Readyforsale,
                    // Auction: row.Auction,
                    // AuctionMark: row.AuctionMark,
                }));

                setUsers(detailRows);
                setEditSrNoCounter(0);

                setFormDataDetail({
                    ...detailRows[0],
                });


                setFormData((prev) => ({
                    ...prev,

                    // doc_no: firstRow.Doc_No || "",
                    // doc_date: firstRow.Doc_Date || prev.doc_date,

                    // Customer_Code: firstRow.Customer_Code || 0,
                    // Broker_code: firstRow.Broker_code || 0,

                    // cc: firstRow.cc || 0,
                    // Bc: firstRow.Bc || 0,

                    Truck_No: firstRow.Truck_No || "",


                    // Net_quantity: totalQty.toFixed(2),
                    // Net_weight: totalNetwt.toFixed(2),

                }));
            } else {

                setUsers([]);
                setFormDataDetail({});
            }
        } catch (error) {
            console.error("Error fetching Awak by Customer:", error);
        }
    };

    const handleAcCode = async (
        code,
        accoid,
        name,
        mobile,
        Gst_No,
        TDSApplicable,
        GSTStateCode,
        cityname,
        statename,
        Commission, Ac_rate, marketcess
    ) => {
        console.log("marketcess", code,
            accoid,
            name,
            mobile,
            Gst_No,
            TDSApplicable,
            GSTStateCode,
            cityname,
            statename,
            Commission, Ac_rate, marketcess)
        setAcCode(code);
        setAcaccoid(accoid);
        setAcName(name);
        setMarketCessApplicable(marketcess);

        let updatedFormData = {
            ...formData,
            Ac_Code: code,
            ac: accoid,
        };

        try {

            let TDSTCSData = ''
            if (code !== '') {
                if (!isEditMode) {
                    TDSTCSData = await AmountCalculation(name, code, updatedFormData);
                }
            }

            setFormData(updatedFormData, TDSTCSData);
        } catch (error) {
            console.error("Error in handleAcCode:", error);
        }
    };



    const handleCustomerCode = async (code, accoid, name, Mobile, GstNo, TDSApplicable, GSTStateCode, cityname, State_Name, Commission, Ac_rate, marketcess) => {

        try {
            setCustomerCode(code);

            let updatedFormData = {
                ...formData,
                Customer_Code: code,
                cc: accoid,
                Commission_Rate: Commission,
                TDS_Rate: Ac_rate,
            };

            // let TDSTCSData = ''
            // if (code !== '') {
            //     if (!isEditMode) {
            //         TDSTCSData = await AmountCalculation(name, code, updatedFormData);
            //     }
            // }


            if (!BrokerCodeManuallySet) {
                setBroker(code);
                brokerName = name
                brokerCode = code

                updatedFormData.Broker_code = code;
                updatedFormData.Bc = accoid;
            }

            setFormData(updatedFormData);

            await fetchAwakByCustomerCode(code);
        } catch (error) {
            console.error("Error in handleCustomerCode:", error);
        }
    };




    const handleBroker = (code, accoid) => {
        setBrokerCodeManuallySet(true)
        setBroker(code);
        setFormData({
            ...formData,
            Broker_code: code,
            Bc: accoid,
        });
    };

    const handleAwakcode = (Doc_No, id) => {
        console.log("handleCustomercode", Doc_No, id)
        setAwakId(id);
        setAwakCode(Doc_No);
        // setFormDataDetail((prevData) => ({
        //     ...prevData,
        //     Awak_No: Doc_No,
        //     Awak_Id: id,
        // }));

        setItemCode("");
        setItemName("");
        setItemCodeAccoid("");
        setLineCode("");
        setLineName("");
        setSelectedFetchedDetail(null);


        setFormDataDetail((prev) => ({
            ...prev,
            Awak_No: Doc_No,
            Awak_Id: id,
            awakdetailId: "",
            Quantity: 0,
            QuantitytoShow: 0,
            wtpr: 0,
            Net_weight: 0,
            Rate: 0,
            Amount: 0,
            container: 0,
            containerAmt: 0,
            KattaPatti: 0,
        }));
    };

    const [hamaliSaleRate, setHamaliSaleRate] = useState('N');

    useEffect(() => {
        if (companyCode && Year_Code) {
            fetchHamaliSaleRate(companyCode, Year_Code);
        }
    }, [companyCode, Year_Code]);

    const fetchHamaliSaleRate = async (company_code, year_code) => {
        try {
            const { data } = await axios.get(`${API_URL}/get-CompanyParameters-Record`, {
                params: {
                    Company_Code: company_code,
                    Year_Code: year_code,
                },
            });

            const rate = (data?.CompanyParameters_data?.HamaliSaleRate || '')
                .toString()
                .trim()
                .toUpperCase();

            setHamaliSaleRate(rate);
        } catch (error) {
            console.error("Error fetching HamaliSaleRate:", error);
            setHamaliSaleRate('N'); // fail-safe
        }
    };


    const getEffectiveHamaliRate = (detail) => {
        if (!detail) return 0;
        const rate = hamaliSaleRate === 'Y'
            ? detail.HamaliSale_rate
            : detail.Hamali_rate;
        return parseFloat(rate) || 0;
    };

    const getEffectiveTolaiRate = (detail) => {
        if (!detail) return 0;
        const rate = hamaliSaleRate === 'Y'
            ? detail.TolaiSale_rate
            : detail.Tolai_rate;
        return parseFloat(rate) || 0;
    };

    const proformaFetchedData = (data) => {
        setisProformafetched(true);
        console.log("data", data)
        isAwaknoDisabled = true;

        const detailsArray = Array.isArray(data.all_data) ? data.all_data : [];

        if (detailsArray.length === 0) {
            console.warn("No detail data found.");
            return;
        }

        const firstDetail = detailsArray[0];

        const formCustomerCode = Number(formData.Customer_Code || billToCode || 0);
        const helpCustomerCode = Number(firstDetail.Customer_Code);
        const helpAuctionMark = Number(firstDetail.AuctionMark);

        // CUSTOMER VALIDATION
        if (
            helpAuctionMark == 'Y' &&
            helpCustomerCode !== 0 &&
            formCustomerCode !== 0 &&
            helpCustomerCode !== formCustomerCode
        ) {
            Swal.fire({
                icon: "error",
                title: "Customer Mismatch",
                text: "Selected Awak record belongs to a different customer.",
                confirmButtonColor: "#d33",
            });
            return;
        }

        setItemCode("");
        setItemName("");
        setItemCodeAccoid("");
        setLineCode("");
        setLineName("");
        setAwakId("");
        itemName = "";
        item_Code = "";

        // Set values from detail
        partyName = firstDetail.FarmerName || "";
        itemName = firstDetail.System_Name_E || "";
        item_Code = firstDetail.Item_Code || "";
        ic = firstDetail.ic || "";
        brandCode = firstDetail.Line_code || "";
        brandName = firstDetail.System_Name_E || "";
        Awakid = firstDetail.Awak_Id || "";
        awakdetailId = firstDetail.Id || "";
        FarmerCode = firstDetail.Ac_code || "";
        fc = firstDetail.ac || "";


        setItemCode(item_Code);
        setItemName(itemName);
        setItemCodeAccoid(ic);
        setLineCode(brandCode);
        setLineName(brandName);
        setAwakId(Awakid);
        // setAwakCode(AwakNo);

        // Set form data detail (for form only, not adding user yet)
        setFormDataDetail((prev) => ({
            ...prev,
            wtpr: parseFloat(firstDetail.wt || 0.0),
            Quantity: parseFloat(0.00),
            QuantitytoShow: parseFloat(firstDetail.balance || 0.00),
            container: parseFloat(firstDetail.Container || 0.00),
            Net_weight: parseFloat(firstDetail.netwt || 0.0),
            Rate: parseFloat(firstDetail.Rate || firstDetail.Salerate || 0.0),
            Amount: parseFloat(firstDetail.Amount || 0.0),
            Awak_No: firstDetail.Doc_No || "",
            Awak_Id: firstDetail.Awak_Id || "",
            awakdetailId: firstDetail.Id || "",
            Farmer_Code: firstDetail.Ac_code || "",
            awkid: firstDetail.HeadId || firstDetail.Awak_Id || 0,
            // Market_Rate: parseFloat(firstDetail.Market_Cess || 0.0),
            // Dekrekh_Rate: parseFloat(firstDetail.Dekrekh || 0.0),
            Hamali: getEffectiveHamaliRate(firstDetail),
            Tolai: getEffectiveTolaiRate(firstDetail),
            fc: firstDetail.ac || "",
            rateSource: firstDetail,
            Display_FarmerName: firstDetail.FarmerName || "",
            Display_AwakDate: firstDetail.Doc_Date || "",
            Display_AwakQty: firstDetail.Awak_Qty ?? "",
        }));


        setSelectedFetchedDetail(firstDetail);
    };



    //WayBill and EInvoice Generation
    const handleGenerateEInvoice = () => {
        setIsOpenEInvoice(true);
    };

    const handleCloseEInvoice = () => {
        setIsOpenEInvoice(false);
    };

    const handleGenerateEwayBill = () => {
        setIsOpenEwayBill(true);
    };

    const handleCloseEwayBill = () => {
        setIsOpenEwayBill(false);
    };

    const handleAdditionChange = (index, value) => {
        const updated = [...additionRows];
        updated[index] = value;
        setAdditionRows(updated);
    };


    const handleAdditionOk = async () => {
        const filteredValues = additionRows.filter(v => v !== "");
        const joinedValue = filteredValues.join("+");

        // Update the formDataDetail first
        setFormDataDetail(prev => {
            const updatedDetail = {
                ...prev,
                additionNetWt: joinedValue
            };

            // Optionally, trigger handleChangeDetail manually
            // Simulate an event object for handleChangeDetail
            handleChangeDetail({
                target: {
                    name: "additionNetWt",
                    value: joinedValue
                }
            });

            return updatedDetail;
        });

        setShowAdditionPopup(false);
    };


    const openAdditionPopup = () => {
        const qty = Number(formDataDetail.Quantity || 0);

        if (!qty || qty <= 0) {
            alert("Please enter Quantity first");
            return;
        }

        // Initialize additionRows from existing additionNetWt if available
        let newRows = Array(qty).fill("");

        if (formDataDetail.additionNetWt) {
            const existingValues = formDataDetail.additionNetWt.split("+");
            existingValues.forEach((val, index) => {
                if (index < newRows.length) newRows[index] = val;
            });
        }

        setAdditionRows(newRows);
        setShowAdditionPopup(true);
    };

    const handleTabNavigation = (e, row, col) => {
        if (e.key === "Tab") {
            e.preventDefault(); // prevent default horizontal tab

            // Calculate index of next cell vertically
            const nextRow = row + 1;
            const index = col * rows + nextRow; // same column, next row

            if (index < quantity) {
                // Focus the next input
                cellRefs.current[index].focus();
            } else {
                // If last row, go to next column top
                const nextCol = col + 1;
                const topIndex = nextCol * rows;
                if (topIndex < quantity) cellRefs.current[topIndex].focus();
            }
        }
    };



    const quantity = additionRows.length;
    const rows = 10; // 0 to 11
    const columns = Math.ceil(quantity / rows);

    const columnTotals = Array(columns).fill(0);

    for (let col = 0; col < columns; col++) {
        for (let row = 0; row < rows; row++) {
            const index = col * rows + row;
            if (index < quantity) {
                const val = parseFloat(additionRows[index]) || 0;
                columnTotals[col] += val;
            }
        }
    }

    return (
        <>
            <UserAuditInfo
                createdBy={formData.Created_By}
                modifiedBy={formData.Modified_By}
                title={"Halad Sale Bill"}
            />
            <ToastContainer autoClose={500} />
            <br></br>
            <ActionButtonGroup
                handleAddOne={handleAddOne}
                addOneButtonEnabled={addOneButtonEnabled}
                handleSaveOrUpdate={handleSaveOrUpdate}
                saveButtonEnabled={saveButtonEnabled}
                isEditMode={isEditMode}
                handleEdit={handleEdit}
                editButtonEnabled={editButtonEnabled}
                handleDelete={handleDelete}
                deleteButtonEnabled={deleteButtonEnabled}
                handleCancel={handleCancel}
                cancelButtonEnabled={cancelButtonEnabled}
                handleBack={handleBack}
                backButtonEnabled={backButtonEnabled}
                isDeleted={formData.IsDeleted === 0}
                permissions={permissions}
                component={<div style={{ display: 'flex' }} >
                    <GulSaleBillReport doc_no={formData.doc_no} Trantype={formData.Tran_Type || TranType} disabledFeild={!addOneButtonEnabled} />
                    <GulSaleBillBatchReport from_doc_no={formData.doc_no} to_doc_no={formData.doc_no} Trantype={formData.Tran_Type || TranType} disabledFeild={!addOneButtonEnabled} />
                    <Dialog open={isOpenEwayBill} onClose={handleCloseEwayBill} maxWidth={650} >
                        <DialogTitle style={{ textAlign: "center" }}>EwayBill Generation</DialogTitle>
                        <IconButton
                            edge="end"
                            color="inherit"
                            onClick={handleCloseEwayBill}
                            aria-label="close"
                            style={{
                                position: 'absolute',
                                right: 30,
                                top: 8,
                                backgroundColor: '#555',
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                        <DialogContent>
                            <EwayBillGeneration
                                doc_no={formData.doc_no}
                                do_no={0}
                                tran_type={"SB"}
                                handleClose={handleCloseEwayBill}
                                Company_Code={companyCode}
                                Year_Code={Year_Code}
                            />
                        </DialogContent>
                    </Dialog>

                    <div style={{ marginLeft: '5px' }}>
                        <Button
                            variant="contained"
                            color="success"
                            onClick={() => handleGenerateEInvoice()}
                            disabled={isEditing || formData.einvoiceno !== "" || formData.IsDeleted === 0}
                            style={{ whiteSpace: 'nowrap' }}
                        >
                            Generate eInvoice
                        </Button>
                    </div>
                    <Dialog open={isOpenEInvoice} onClose={handleCloseEInvoice} maxWidth={650} >
                        <DialogTitle GSTData style={{ textAlign: "center" }}>E-Invoice Generation</DialogTitle>
                        <IconButton
                            edge="end"
                            color="inherit"
                            onClick={handleCloseEInvoice}
                            aria-label="close"
                            style={{
                                position: 'absolute',
                                right: 30,
                                top: 8,
                                backgroundColor: '#555',
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                        <DialogContent>
                            <EInvoiceGeneration
                                doc_no={formData.doc_no}
                                do_no={formData.DO_No}
                                tran_type={"SB"}
                                handleClose={handleCloseEInvoice}
                                Company_Code={companyCode}
                                Year_Code={Year_Code}
                            />
                        </DialogContent>
                    </Dialog>

                </div>}
            />
            <NavigationButtons
                handleFirstButtonClick={handleFirstButtonClick}
                handlePreviousButtonClick={handlePreviousButtonClick}
                handleNextButtonClick={handleNextButtonClick}
                handleLastButtonClick={handleLastButtonClick}
                highlightedButton={highlightedButton}
                isEditing={isEditing}
            />

            <form onSubmit={handleSubmit}>
                <Grid container alignItems="center" spacing={1} mt={0.5}>
                    <Grid item xs={12} sm={1}>
                        <FormControl fullWidth>
                            <TextField
                                label="Change No"
                                variant="outlined"
                                name="changeNo"
                                autoComplete="off"
                                onKeyDown={handleKeyDown}
                                disabled={!addOneButtonEnabled}
                                fullWidth
                                size="small"
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={6} sm={1}>
                        <FormControl >
                            <TextField
                                label="Bill No"
                                variant="outlined"
                                name="doc_no"
                                autoComplete="off"
                                value={formData.doc_no}
                                onChange={handleChange}
                                disabled
                                fullWidth
                                size="small"
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={6} sm={1}>
                        <FormControl >
                            <TextField
                                inputRef={inputRef}
                                type="date"
                                label="Date"
                                variant="outlined"
                                name="doc_date"
                                value={formData.doc_date}
                                onChange={handleChange}
                                disabled={!isEditing && addOneButtonEnabled}
                                fullWidth
                                size="small"
                                InputLabelProps={{
                                    style: { fontSize: '14px' },
                                }}
                                InputProps={{
                                    style: { fontSize: '12px', height: '40px' },
                                }}
                            />
                        </FormControl>
                    </Grid>

                </Grid>

                <div className="SugarSaleBill-row" style={{ marginTop: "10px" }}>
                    <label htmlFor="Customer_Code" className="SugarSaleBillLabel" >
                        Sauda Code:
                    </label>
                    <div >
                        <div style={{ fontWeight: "bold", marginLeft: "21px" }}>
                            <AccountMasterHelp
                                onAcCodeClick={handleCustomerCode}
                                CategoryName={billToName || bill_To_Name}
                                CategoryCode={billToCode}
                                name="Customer_Code"
                                Ac_type={[]}
                                disabledFeild={!isEditing && addOneButtonEnabled}
                            />
                        </div>
                    </div>
                </div>
                <div className="SugarSaleBill-row">
                    <label htmlFor="Ac_Code" className="SugarSaleBillLabel"  >
                        Customer Code:
                    </label>
                    <div >
                        <div style={{ fontWeight: "bold", marginLeft: "0.5px" }}>
                            <AccountMasterHelp
                                onAcCodeClick={handleAcCode}
                                CategoryName={millName}
                                CategoryCode={millCode}
                                name="Ac_Code"
                                Ac_type={[]}
                                disabledFeild={!isEditing && addOneButtonEnabled}
                            />
                        </div>
                    </div>
                </div>

                <div className="SugarSaleBill-row">
                    <label htmlFor="Broker_code" className="SugarSaleBillLabel"  >
                        Broker Code:
                    </label>
                    <div >
                        <div style={{ fontWeight: "bold", marginLeft: "21px" }}>
                            <AccountMasterHelp
                                onAcCodeClick={handleBroker}
                                CategoryName={brokerName}
                                CategoryCode={brokerCode}
                                name="Broker_code"
                                Ac_type=""
                                disabledFeild={!isEditing && addOneButtonEnabled}
                            />
                        </div>
                    </div>
                </div>

                <div className="SaleBill-row">
                    <Grid container spacing={2} mt={2}>
                        <Grid item xs={2} sm={1}>
                            <FormControl fullWidth variant="outlined" disabled={!isEditing && addOneButtonEnabled}>
                                <InputLabel>Sauda Type</InputLabel>
                                <Select
                                    id="Sauda_Type"
                                    name="Sauda_Type"
                                    value={formData.Sauda_Type}
                                    onChange={handleChange}
                                    // onKeyDown={(event) => handleSelectKeyDown(event, "Tran_Type")}
                                    label="Type"
                                    size="small"
                                // inputRef={TranTypeInputRef}
                                >
                                    <MenuItem value="J">Jaggery</MenuItem>
                                    <MenuItem value="T">Turmeric</MenuItem>

                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={2} sm={1}>
                            <FormControl fullWidth variant="outlined" disabled={!isEditing && addOneButtonEnabled}>
                                <InputLabel>Tran Type</InputLabel>
                                <Select
                                    id="Tran_Type"
                                    name="Tran_Type"
                                    value={formData.Tran_Type}
                                    onChange={handleDropdownChange}
                                    disabled={!addOneButtonEnabled}
                                    // onKeyDown={(event) => handleSelectKeyDown(event, "Tran_Type")}
                                    label="Type"
                                    size="small"
                                // inputRef={TranTypeInputRef}
                                >
                                    <MenuItem value="GS">GS</MenuItem>
                                    <MenuItem value="OS">Outside City</MenuItem>
                                    <MenuItem value="MS">MAHALINGPUR Sale</MenuItem>

                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={6} sm={1} mr={4}>
                            <FormControl>
                                <TextField
                                    type="date"
                                    label="Sauda Date"
                                    variant="outlined"
                                    name="SaudaDate"
                                    value={formData.SaudaDate}
                                    onChange={handleChange}
                                    disabled={!isEditing && addOneButtonEnabled}
                                    fullWidth
                                    size="small"
                                    InputLabelProps={{
                                        shrink: true,
                                        style: { fontSize: '14px' },
                                    }}
                                    InputProps={{
                                        style: { fontSize: '12px', height: '40px' },
                                    }}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={4} sm={1}>
                            <TextField
                                label="Due Days"
                                name="Due_days"
                                variant="outlined"
                                autoComplete="off"
                                value={formData.Due_days}
                                onChange={handleChange}
                                disabled={!isEditing && addOneButtonEnabled}
                                fullWidth
                                size="small"
                                inputProps={{
                                    inputMode: 'decimal',
                                    pattern: '[0-9]*[.,]?[0-9]+',
                                    onInput: validateNumericInput,
                                }}
                            />
                        </Grid>

                        <Grid item xs={4} sm={1}>
                            <TextField
                                label="Commission Rate"
                                name="Commission_Rate"
                                variant="outlined"
                                autoComplete="off"
                                value={formData.Commission_Rate}
                                onChange={handleChange}
                                onKeyDown={handleKeyDownCalculations}
                                disabled={!isEditing && addOneButtonEnabled}
                                fullWidth
                                size="small"
                                inputProps={{
                                    inputMode: 'decimal',
                                    pattern: '[0-9]*[.,]?[0-9]+',
                                    onInput: validateNumericInput,
                                }}
                            />
                        </Grid>

                        <Grid item xs={1.5}>
                            <TextField
                                label="Truck No"
                                variant="outlined"
                                name="Truck_No"
                                autoComplete="off"
                                value={formData.Truck_No}
                                onChange={handleChange}
                                disabled={!isEditing && addOneButtonEnabled}
                                fullWidth
                                size="small"
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        color: 'black',
                                        backgroundColor: 'white',
                                        opacity: 1,
                                        '& .Mui-disabled': {
                                            color: 'black',
                                            WebkitTextFillColor: 'black',
                                            opacity: 1,
                                        },
                                    },
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <TextField
                                label="Narration:"
                                name="Narration"
                                variant="outlined"
                                autoComplete="off"
                                fullWidth
                                multiline
                                rows={2}
                                value={formData.Narration}
                                onChange={handleChange}
                                disabled={!isEditing && addOneButtonEnabled}
                                size="small"
                            />
                        </Grid>
                    </Grid>
                </div>

                {isLoading && (
                    <div className="loading-overlay">
                        <div className="spinner-container">
                            <SaveUpdateSpinner />
                        </div>
                    </div>
                )}

                <div style={{ marginTop: "-10px" }}>
                    <AddButton openPopup={openPopup} isEditing={isEditing} ref={addButtonRef} setFocusToFirstField={setFocusToFirstField} />
                </div>

                {/*detail part popup functionality and Validation part Grid view */}
                <div className="">
                    {showPopup && (
                        <div className="sugar-salebill-modal" role="dialog" style={{ display: "block" }}>
                            <div className="sugar-salebill-modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="sugar-salebill-modal-header">
                                        <h5 className="sugar-salebill-modal-title">
                                            {selectedUser.id ? "Update Sale Bill" : "Add Sale Bill"}
                                        </h5>
                                        <button
                                            type="button"
                                            onClick={closePopup}
                                            aria-label="Close"
                                            style={{
                                                width: "40px",
                                                height: "45px",
                                                borderRadius: "4px"
                                            }}
                                        >
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="SugarSaleBill-row">
                                        <form>
                                            <div className="SugarSaleBill-row">
                                                <label htmlFor="Mill_Name" className="SugarSaleBillLabel" >
                                                    Awak No:
                                                </label>
                                                <div >
                                                    <div >
                                                        <AwakEntryhelp
                                                            helpMode="SALE"
                                                            onAcCodeClick={handleAwakcode}
                                                            // Awak_No={formDataDetail.Awak_No}
                                                            Doc_No={formDataDetail.Awak_No}
                                                            DetailId={formDataDetail.Awak_Id}
                                                            onFetchedData={proformaFetchedData}
                                                            Ac_type={[]}
                                                            name="Awak_No"
                                                            tabIndexHelp={0}
                                                            firstInputRef={firstInputRef}
                                                            enableFetchData={true}
                                                            enableFarmerFilter={false}
                                                            displayFarmerName={selectedFetchedDetail?.FarmerName || ""}
                                                            displayAwakDate={selectedFetchedDetail?.Doc_Date || ""}
                                                            displayQty={
                                                                selectedFetchedDetail?.Awak_Qty || 0
                                                            }

                                                        />
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="SugarSaleBill-row" >

                                                <label htmlFor="Mill_Name" className="SugarSaleBillLabel" >
                                                    Item Code :
                                                </label>
                                                <div >
                                                    <div >
                                                        <SystemmasterHelp
                                                            onAcCodeClick={handleItemCode}
                                                            CategoryName={item_Name}
                                                            CategoryCode={itemCode}
                                                            SystemType={"I"}
                                                            name="Item_Code"

                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="SugarSaleBill-row" >
                                                <label htmlFor="Mill_Name" className="SugarSaleBillLabel" >
                                                    Line Code :
                                                </label>
                                                <div >
                                                    <div>
                                                        <SystemmasterHelp
                                                            onAcCodeClick={handleLineCode}
                                                            CategoryName={line_name}
                                                            CategoryCode={line_code}
                                                            SystemType="L"
                                                            name="Linecode"
                                                        />
                                                    </div>
                                                </div>

                                                <Grid item xs={12} sm={3} style={{ marginLeft: "250px" }}>
                                                    <TextField
                                                        label="Sr No"
                                                        type="number"
                                                        name="SrNo"
                                                        value={formDataDetail.SrNo ?? ""}
                                                        onChange={handleChangeDetail}
                                                        onKeyDown={handleKeyDownCalculations}
                                                        fullWidth
                                                        autoComplete="off"
                                                        variant="outlined"
                                                        size="small"
                                                        disabled
                                                    />
                                                </Grid>
                                            </div>

                                            <Grid container spacing={2} className="mt-3">
                                                <Grid item xs={12} sm={3}>
                                                    <TextField
                                                        label="Quantity To Show"
                                                        name="QuantitytoShow"
                                                        value={formDataDetail.QuantitytoShow || ""}
                                                        onChange={handleChangeDetail}
                                                        fullWidth
                                                        autoComplete="off"
                                                        variant="outlined"
                                                        size="small"
                                                        disabled
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={3}>
                                                    <TextField
                                                        label="Quantity"
                                                        name="Quantity"
                                                        value={formDataDetail.Quantity || ""}
                                                        onChange={handleChangeDetail}
                                                        onKeyDown={handleKeyDownCalculations}
                                                        inputRef={quantityRef}
                                                        fullWidth
                                                        autoComplete="off"
                                                        variant="outlined"
                                                        size="small"
                                                        disabled={!isEditing && addOneButtonEnabled}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label="TolaiDar Name"
                                                        name="tolaidarName"
                                                        value={formDataDetail.tolaidarName || ""}
                                                        onChange={handleChangeDetail}
                                                        onKeyDown={handleKeyDownCalculations}
                                                        fullWidth
                                                        autoComplete="off"
                                                        variant="outlined"
                                                        size="small"
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={3}>
                                                    <TextField
                                                        label="KattaPatti"
                                                        name="KattaPatti"
                                                        value={formDataDetail.KattaPatti || ""}
                                                        onChange={handleChangeDetail}
                                                        onKeyDown={handleKeyDownCalculations}
                                                        fullWidth
                                                        autoComplete="off"
                                                        variant="outlined"
                                                        size="small"
                                                        disabled={!isEditing && addOneButtonEnabled}
                                                    />
                                                </Grid>
                                                {/* <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label="Wt/Per"
                                                        name="wtpr"
                                                        value={formDataDetail.wtpr || ""}
                                                        onChange={handleChangeDetail}
                                                        onKeyDown={handleKeyDownCalculations}
                                                        fullWidth
                                                        autoComplete="off"
                                                        variant="outlined"
                                                        size="small"
                                                    />

                                                </Grid> */}


                                            </Grid>

                                            <Grid container spacing={2} className="mt-3">

                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label="Addition to Net Weight"
                                                        value={formDataDetail.additionNetWt || ""}
                                                        name="additionNetWt"
                                                        onChange={handleChangeDetail}
                                                        fullWidth
                                                        autoComplete="off"
                                                        variant="outlined"
                                                        size="small"
                                                        disabled
                                                    />

                                                </Grid>
                                                <Grid item xs={12} sm={1}>
                                                    <button
                                                        type="button"
                                                        onClick={() => openAdditionPopup()}
                                                        style={{
                                                            height: "40px",
                                                            width: "40px",
                                                            cursor: "pointer"
                                                        }}
                                                        disabled={!isEditing && addOneButtonEnabled}
                                                    >
                                                        +
                                                    </button>
                                                </Grid>
                                                {showAdditionPopup && (
                                                    <div className="sugar-salebill-modal" style={{ display: "block" }}>
                                                        <div className="sugar-salebill-modal-dialog">
                                                            <div className="modal-content">
                                                                <div className="sugar-salebill-modal-header">
                                                                    <h5>Addition Details</h5>
                                                                    <button onClick={() => setShowAdditionPopup(false)}>×</button>
                                                                </div>

                                                                <div style={{ overflow: "auto" }}>
                                                                    <table
                                                                        style={{
                                                                            borderCollapse: "collapse",
                                                                            border: "1px solid #333"
                                                                        }}
                                                                    >
                                                                        <thead>
                                                                            <tr>
                                                                                {/* Empty corner cell */}
                                                                                {/* <th style={{ border: "1px solid #333", width: 40 }}></th> */}

                                                                                {[...Array(columns)].map((_, col) => (
                                                                                    <th
                                                                                        key={col}
                                                                                        style={{
                                                                                            border: "1px solid #333",
                                                                                            width: 40,
                                                                                            height: 30,
                                                                                            textAlign: "center"
                                                                                        }}
                                                                                    >
                                                                                        {col}
                                                                                    </th>
                                                                                ))}
                                                                            </tr>
                                                                        </thead>


                                                                        <tbody>
                                                                            {[...Array(rows)].map((_, row) => (
                                                                                <tr key={row}>
                                                                                    {[...Array(columns)].map((_, col) => {
                                                                                        const index = col * rows + row;

                                                                                        if (index >= quantity) return <td key={col}></td>;

                                                                                        return (
                                                                                            <td
                                                                                                key={col}
                                                                                                style={{
                                                                                                    border: "1px solid #333",
                                                                                                    width: 85,
                                                                                                    height: 35
                                                                                                }}
                                                                                            >
                                                                                                <input
                                                                                                    type="text"
                                                                                                    value={additionRows[index]}
                                                                                                    onChange={(e) => handleAdditionChange(index, e.target.value)}
                                                                                                    ref={(el) => (cellRefs.current[index] = el)}
                                                                                                    onKeyDown={(e) => handleTabNavigation(e, row, col)}
                                                                                                    style={{
                                                                                                        width: "100%",
                                                                                                        height: "100%",
                                                                                                        border: "none",
                                                                                                        outline: "none",
                                                                                                        textAlign: "center"
                                                                                                    }}
                                                                                                />

                                                                                            </td>
                                                                                        );
                                                                                    })}
                                                                                </tr>
                                                                            ))}

                                                                        </tbody>

                                                                        <tfoot>
                                                                            <tr>

                                                                                {columnTotals.map((total, col) => (
                                                                                    <td
                                                                                        key={col}
                                                                                        style={{
                                                                                            border: "1px solid #333",
                                                                                            fontWeight: "bold",
                                                                                            textAlign: "center"
                                                                                        }}
                                                                                    >
                                                                                        {total.toFixed(2)}
                                                                                    </td>
                                                                                ))}
                                                                            </tr>
                                                                        </tfoot>


                                                                    </table>
                                                                </div>



                                                                <div className="modal-footer">
                                                                    <button onClick={handleAdditionOk}>OK</button>
                                                                    <button onClick={() => setShowAdditionPopup(false)}>Cancel</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}



                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label="Bags Sut"
                                                        name="BagSut"
                                                        value={formDataDetail.BagSut || 0}
                                                        onChange={handleChangeDetail}
                                                        // onKeyDown={handleKeyDownCalculations}
                                                        // inputRef={netWeightRef}
                                                        fullWidth
                                                        autoComplete="off"
                                                        variant="outlined"
                                                        size="small"
                                                        disabled={!isEditing && addOneButtonEnabled}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label="EXTRA Sut"
                                                        name="ExtraSut"
                                                        value={formDataDetail.ExtraSut || 0}
                                                        onChange={handleChangeDetail}
                                                        // onKeyDown={handleKeyDownCalculations}
                                                        // inputRef={netWeightRef}
                                                        type="number"
                                                        inputProps={{ step: "0.01" }}
                                                        fullWidth
                                                        autoComplete="off"
                                                        variant="outlined"
                                                        size="small"
                                                        disabled={!isEditing && addOneButtonEnabled}
                                                    />
                                                </Grid>



                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label="Gross Weight"
                                                        name="GrossWt"
                                                        value={formDataDetail.GrossWt || 0}
                                                        onChange={handleChangeDetail}
                                                        onKeyDown={handleKeyDownCalculations}
                                                        // inputRef={netWeightRef}
                                                        fullWidth
                                                        autoComplete="off"
                                                        variant="outlined"
                                                        size="small"

                                                        disabled={!isEditing && addOneButtonEnabled}
                                                    />
                                                </Grid>


                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label="Net Weight"
                                                        name="Net_weight"
                                                        value={formDataDetail.Net_weight || 0}
                                                        onChange={handleChangeDetail}
                                                        onKeyDown={handleKeyDownCalculations}
                                                        // inputRef={netWeightRef}
                                                        fullWidth
                                                        autoComplete="off"
                                                        variant="outlined"
                                                        size="small"
                                                        disabled={!isEditing && addOneButtonEnabled}
                                                        inputProps={{
                                                            step: "0.02",   // allows 200.50, 0.25, etc.
                                                            min: 0
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label="Rate"
                                                        name="Rate"
                                                        value={formDataDetail.Rate || ""}
                                                        onChange={handleChangeDetail}
                                                        onKeyDown={handleKeyDownCalculations}
                                                        fullWidth
                                                        autoComplete="off"
                                                        variant="outlined"
                                                        required
                                                        size="small"
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={2}>
                                                    <TextField
                                                        label="Container"
                                                        name="container"
                                                        value={formDataDetail.container || ""}
                                                        onChange={handleChangeDetail}
                                                        fullWidth
                                                        autoComplete="off"
                                                        variant="outlined"
                                                        size="small"
                                                        type="number"
                                                        inputProps={{ step: "0.01" }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={4}>
                                                    <TextField
                                                        label="Container Amount"
                                                        name="containerAmt"
                                                        value={formDataDetail.containerAmt || ""}
                                                        onChange={handleChangeDetail}
                                                        fullWidth
                                                        autoComplete="off"
                                                        variant="outlined"
                                                        size="small"
                                                        type="number"
                                                        inputProps={{ step: "0.01" }}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label="Amount"
                                                        name="Amount"
                                                        value={formDataDetail.Amount || ""}
                                                        onChange={handleChangeDetail}
                                                        onKeyDown={handleKeyDownCalculations}
                                                        fullWidth
                                                        autoComplete="off"
                                                        variant="outlined"
                                                        size="small"
                                                        disabled
                                                    />
                                                </Grid>
                                            </Grid>

                                            {/* <Grid container spacing={2} className="mt-3">


                                            </Grid> */}
                                        </form>
                                    </div>

                                    <div className="modal-footer">
                                        {selectedUser.id ? (
                                            <DetailUpdateButton updateUser={updateUser} />
                                        ) : (
                                            <DetailAddButtom addUser={addUser} />
                                        )}
                                        <DetailCloseButton closePopup={closePopup} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    <div >

                        <TableContainer component={Paper} className="mt-2" sx={{ width: "72%" }} >
                            <Table aria-label="user table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={headerCellStyle}>Actions</TableCell>
                                        {/* <TableCell sx={headerCellStyle}>RowAction</TableCell> */}
                                        <TableCell sx={headerCellStyle}>ID</TableCell>
                                        <TableCell sx={headerCellStyle}>Sr No</TableCell>
                                        <TableCell sx={headerCellStyle}>Awak No</TableCell>
                                        <TableCell sx={headerCellStyle}>Farmer Code</TableCell>
                                        <TableCell sx={headerCellStyle}>Item Code</TableCell>
                                        <TableCell sx={headerCellStyle}>Item Name</TableCell>
                                        {/* <TableCell sx={headerCellStyle}>Line Code</TableCell> */}
                                        <TableCell sx={headerCellStyle}>Line Name</TableCell>
                                        <TableCell sx={headerCellStyle}>Quantity</TableCell>
                                        <TableCell sx={headerCellStyle}>Nt/Wt</TableCell>
                                        <TableCell sx={headerCellStyle}>Wt/Per</TableCell>
                                        <TableCell sx={headerCellStyle}>Rate</TableCell>
                                        <TableCell sx={headerCellStyle}>Amount</TableCell>
                                        <TableCell sx={headerCellStyle}>Market Cess</TableCell>
                                        <TableCell sx={headerCellStyle}>DekhRekh</TableCell>
                                        <TableCell sx={headerCellStyle}>Leavy</TableCell>
                                        <TableCell sx={headerCellStyle}>Container</TableCell>
                                        <TableCell sx={headerCellStyle}>Hamali</TableCell>
                                        <TableCell sx={headerCellStyle}>Tolai</TableCell>
                                        <TableCell sx={headerCellStyle}>Print</TableCell>
                                        {/* <TableCell sx={headerCellStyle}>Saledetailid</TableCell> */}
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{
                                    '& .MuiTableRow-root': { height: 26 },
                                    '& .MuiTableCell-root': {
                                        padding: '1px 3px',
                                        lineHeight: 1.1
                                    }
                                }}>
                                    {users.map((user) => (
                                        <TableRow key={user.id}>
                                            <TableCell sx={{ padding: '0px 1px' }}>
                                                {user.rowaction === "add" || user.rowaction === "update" || user.rowaction === "Normal" ? (
                                                    <>
                                                        <EditButton
                                                            editUser={editUser}
                                                            user={user}
                                                            isEditing={isEditing}
                                                        />
                                                        <DeleteButton
                                                            deleteModeHandler={deleteModeHandler}
                                                            user={user}
                                                            isEditing={isEditing}
                                                        />
                                                    </>
                                                ) : user.rowaction === "DNU" || user.rowaction === "delete" ? (
                                                    <OpenButton openDelete={openDelete} user={user} />
                                                ) : null}
                                            </TableCell>
                                            {/* <TableCell>{user.rowaction}</TableCell> */}
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{user.detail_id}</TableCell>
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{user.SrNo}</TableCell>
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{user.Awak_No}</TableCell>
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{user.Farmer_Code}</TableCell>
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{user.Item_Code}</TableCell>
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{user.item_Name}</TableCell>
                                            {/* <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{user.Linecode}</TableCell> */}
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{user.brand_name}</TableCell>
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{user.Quantity}</TableCell>
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{user.Net_weight}</TableCell>
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{user.wtpr}</TableCell>
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{formatReadableAmount(user.Rate)}</TableCell>
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{formatReadableAmount(user.Amount)}</TableCell>
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{user.Market_Cess}</TableCell>
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{user.Dekrekh}</TableCell>
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{user.leavy}</TableCell>
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{user.containerAmt}</TableCell>
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{formatReadableAmount(user.hamalical)}</TableCell>
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{formatReadableAmount(user.Tolaical)}</TableCell>
                                            <TableCell>
                                                <GulSaleBillDetailReport
                                                    salebilldetailId={user.salebilldetailId}   //  CORRECT
                                                    disabledFeild={!addOneButtonEnabled}
                                                    rows={users}
                                                />
                                            </TableCell>

                                            {/* <TableCell>{user.saledetailid}</TableCell> */}
                                        </TableRow>
                                    ))}

                                    <TableRow>
                                        <TableCell colSpan={7} sx={{ fontWeight: "bold", textAlign: "right" }}>
                                            Total:
                                        </TableCell>

                                        <TableCell></TableCell>

                                        <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>
                                            {totalQty.toFixed(2)}
                                        </TableCell>

                                        <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>
                                            {totalNetwt.toFixed(2)}
                                        </TableCell>

                                        <TableCell></TableCell>
                                        <TableCell></TableCell>

                                        <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>
                                            {totalamt.toFixed(2)}
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>
                                            {totalMrktcess.toFixed(2)}
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>
                                            {totaldekhRek.toFixed(2)}
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>
                                            {totalleavy.toFixed(2)}
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>
                                            {totalcont.toFixed(2)}
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>
                                            {totalhamali.toFixed(2)}
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>
                                            {totaltolai.toFixed(2)}
                                        </TableCell>

                                    </TableRow>

                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>

                <div style={{ display: 'grid' }} >

                    <div>
                        <div>
                            {/* <Grid container spacing={1} mt={-30} sx={{ textAlign: 'left' }}> */}
                            <Grid container spacing={1} mt={1} >
                                <Grid item xs={4} sm={1}>
                                    <label className="SugarSaleBillLabel">Net Quantity :</label>
                                </Grid>
                                <Grid>
                                    <TextField
                                        variant="outlined"
                                        fullWidth
                                        name="Net_quantity"
                                        autoComplete="off"
                                        value={formData.Net_quantity}
                                        onKeyDown={handleKeyDownCalculations}
                                        onChange={handleChange}
                                        disabled
                                        error={Boolean(formErrors.Net_quantity)}
                                        helperText={formErrors.Net_quantity || ''}
                                        size="small"
                                        inputProps={{
                                            sx: { textAlign: 'right' },
                                            inputMode: 'decimal',
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                fontSize: '16px',
                                                fontWeight: 'bold',
                                                color: 'black',
                                                backgroundColor: 'white',
                                                opacity: 1,
                                                '& .Mui-disabled': {
                                                    color: 'black',
                                                    WebkitTextFillColor: 'black',
                                                    opacity: 1,
                                                },
                                            },
                                        }}

                                    />
                                </Grid>


                                <Grid item xs={4} sm={1}>
                                    <label className="SugarSaleBillLabel">Net Weight :</label>
                                </Grid>
                                <Grid>
                                    <TextField
                                        variant="outlined"
                                        fullWidth
                                        name="Net_weight"
                                        autoComplete="off"
                                        value={formData.Net_weight}
                                        onKeyDown={handleKeyDownCalculations}
                                        onChange={handleChange}
                                        disabled
                                        error={Boolean(formErrors.Net_weight)}
                                        helperText={formErrors.Net_weight || ''}
                                        size="small"
                                        inputProps={{
                                            sx: { textAlign: 'right' },
                                            inputMode: 'decimal',
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                fontSize: '16px',
                                                fontWeight: 'bold',
                                                color: 'black',
                                                backgroundColor: 'white',
                                                opacity: 1,
                                                '& .Mui-disabled': {
                                                    color: 'black',
                                                    WebkitTextFillColor: 'black',
                                                    opacity: 1,
                                                },
                                            },
                                        }}

                                    />
                                </Grid>
                            </Grid>



                            <div>
                                <div className="SaleBill-row" >
                                    <Grid container spacing={1} mt={-20} sx={{ textAlign: 'left' }}>
                                        <Grid container spacing={1} justifyContent="flex-end" alignItems="center" >
                                            <Grid item xs={1}>
                                                <label className="SugarSaleBillLabel">SubTotal :</label>
                                            </Grid>
                                            <Grid item xs={12} sm={2}>
                                                <TextField
                                                    variant="outlined"
                                                    name="SubTotal"
                                                    autoComplete="off"
                                                    value={formatReadableAmount(formData.SubTotal)}
                                                    disabled
                                                    fullWidth
                                                    InputLabelProps={{ shrink: true }}
                                                    error={!!formErrors.SubTotal}
                                                    helperText={formErrors.SubTotal}
                                                    size="small"
                                                    inputProps={{
                                                        sx: { textAlign: 'right' },
                                                        inputMode: 'decimal',
                                                        pattern: '[0-9]*[.,]?[0-9]+',
                                                        onInput: validateNumericInput,
                                                    }}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            fontSize: '16px',
                                                            fontWeight: 'bold',
                                                            color: 'black',
                                                            backgroundColor: 'white',
                                                            opacity: 1,
                                                            '& .Mui-disabled': {
                                                                color: 'black',
                                                                WebkitTextFillColor: 'black',
                                                                opacity: 1,
                                                            },
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>



                                        <Grid container spacing={1} justifyContent="flex-end" alignItems="center" style={{ marginTop: '-6px' }}>
                                            <Grid item xs={1}>
                                                <label className="SugarSaleBillLabel">Leavy:</label>
                                            </Grid>
                                            <Grid item xs={12} sm={2}>
                                                <TextField
                                                    variant="outlined"
                                                    fullWidth
                                                    name="Leavy"
                                                    autoComplete="off"
                                                    value={formData.Leavy || 0.0}
                                                    onKeyDown={handleKeyDownCalculations}
                                                    onChange={handleChange}
                                                    disabled
                                                    error={Boolean(formErrors.Leavy)}
                                                    helperText={formErrors.Leavy || ''}
                                                    size="small"
                                                    inputProps={{
                                                        sx: { textAlign: 'right' },
                                                        inputMode: 'decimal',
                                                    }}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            fontSize: '16px',
                                                            fontWeight: 'bold',
                                                            color: 'black',
                                                            backgroundColor: 'white',
                                                            opacity: 1,
                                                            '& .Mui-disabled': {
                                                                color: 'black',
                                                                WebkitTextFillColor: 'black',
                                                                opacity: 1,
                                                            },
                                                        },
                                                    }}

                                                />
                                            </Grid>
                                        </Grid>





                                        <Grid container spacing={1} justifyContent="flex-end" alignItems="center" style={{ marginTop: '-6px' }} >

                                            <Grid item xs={1}>
                                                <label className="SugarSaleBillLabel">Commission :</label>
                                            </Grid>
                                            <Grid item xs={12} sm={2}>
                                                <TextField
                                                    variant="outlined"
                                                    name="Commission"
                                                    autoComplete="off"
                                                    value={formData.Commission}
                                                    onChange={handleChange}
                                                    onKeyDown={handleKeyDownCalculations}
                                                    disabled
                                                    fullWidth
                                                    InputLabelProps={{ shrink: true }}
                                                    error={!!formErrors.Commission}
                                                    helperText={formErrors.Commission}
                                                    size="small"
                                                    inputProps={{
                                                        sx: { textAlign: 'right' },
                                                        inputMode: 'decimal',
                                                        pattern: '[0-9]*[.,]?[0-9]+',
                                                        onInput: validateNumericInput,
                                                    }}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            fontSize: '16px',
                                                            fontWeight: 'bold',
                                                            color: 'black',
                                                            backgroundColor: 'white',
                                                            opacity: 1,
                                                            '& .Mui-disabled': {
                                                                color: 'black',
                                                                WebkitTextFillColor: 'black',
                                                                opacity: 1,
                                                            },
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={1} justifyContent="flex-end" alignItems="center" style={{ marginTop: '-6px' }} >

                                            <Grid item xs={1}>
                                                <label className="SugarSaleBillLabel">Container :</label>
                                            </Grid>
                                            <Grid item xs={12} sm={2}>
                                                <TextField
                                                    variant="outlined"
                                                    name="Conatiner"
                                                    autoComplete="off"
                                                    value={formData.Container}
                                                    onChange={handleChange}
                                                    onKeyDown={handleKeyDownCalculations}
                                                    disabled
                                                    fullWidth
                                                    InputLabelProps={{ shrink: true }}
                                                    error={!!formErrors.Container}
                                                    helperText={formErrors.Container}
                                                    size="small"
                                                    inputProps={{
                                                        sx: { textAlign: 'right' },
                                                        inputMode: 'decimal',
                                                        pattern: '[0-9]*[.,]?[0-9]+',
                                                        onInput: validateNumericInput,
                                                    }}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            fontSize: '16px',
                                                            fontWeight: 'bold',
                                                            color: 'black',
                                                            backgroundColor: 'white',
                                                            opacity: 1,
                                                            '& .Mui-disabled': {
                                                                color: 'black',
                                                                WebkitTextFillColor: 'black',
                                                                opacity: 1,
                                                            },
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={1} justifyContent="flex-end" alignItems="center" style={{ marginTop: '-6px' }}>
                                            <Grid item xs={1}>
                                                <label className="SugarSaleBillLabel">Round Off :</label>
                                            </Grid>
                                            <Grid item xs={12} sm={2}>
                                                <TextField
                                                    variant="outlined"
                                                    fullWidth
                                                    name="RoundOff"
                                                    autoComplete="off"
                                                    value={formData.RoundOff}
                                                    onKeyDown={handleKeyDownCalculations}
                                                    onChange={handleChange}
                                                    disabled
                                                    error={Boolean(formErrors.RoundOff)}
                                                    helperText={formErrors.RoundOff || ''}
                                                    size="small"
                                                    inputProps={{
                                                        sx: { textAlign: 'right' },
                                                        inputMode: 'decimal',
                                                        pattern: '[0-9]*[.,]?[0-9]+',
                                                        onInput: validateNumericInput,
                                                    }}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            fontSize: '16px',
                                                            fontWeight: 'bold',
                                                            color: 'black',
                                                            backgroundColor: 'white',
                                                            opacity: 1,
                                                            '& .Mui-disabled': {
                                                                color: 'black',
                                                                WebkitTextFillColor: 'black',
                                                                opacity: 1,
                                                            },
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>




                                        <Grid container spacing={1} justifyContent="flex-end" alignItems="center" style={{ marginTop: '-6px' }}>
                                            <Grid item xs={1}>
                                                <label className="SugarSaleBillLabel">Expense SubTotal :</label>
                                            </Grid>
                                            <Grid item xs={12} sm={2}>
                                                <TextField
                                                    variant="outlined"
                                                    fullWidth
                                                    name="Expense_Subtotal"
                                                    autoComplete="off"
                                                    value={formData.Expense_Subtotal}
                                                    onKeyDown={handleKeyDownCalculations}
                                                    onChange={handleChange}
                                                    disabled
                                                    error={Boolean(formErrors.Expense_Subtotal)}
                                                    helperText={formErrors.Expense_Subtotal || ''}
                                                    size="small"
                                                    inputProps={{
                                                        sx: { textAlign: 'right' },
                                                        inputMode: 'decimal',
                                                        pattern: '[0-9]*[.,]?[0-9]+',
                                                        onInput: validateNumericInput,
                                                    }}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            fontSize: '16px',
                                                            fontWeight: 'bold',
                                                            color: 'black',
                                                            backgroundColor: 'white',
                                                            opacity: 1,
                                                            '& .Mui-disabled': {
                                                                color: 'black',
                                                                WebkitTextFillColor: 'black',
                                                                opacity: 1,
                                                            },
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>


                                        <Grid container spacing={1} justifyContent="flex-end" alignItems="center" style={{ marginTop: '-6px' }}>
                                            <Grid item xs={1}>
                                                <label className="SugarSaleBillLabel">Hamali :</label>
                                            </Grid>
                                            <Grid item xs={12} sm={2}>
                                                <TextField
                                                    variant="outlined"
                                                    fullWidth
                                                    name="HamaliAmt"
                                                    autoComplete="off"
                                                    value={formData.HamaliAmt}
                                                    onKeyDown={handleKeyDownCalculations}
                                                    onChange={handleChange}
                                                    disabled
                                                    error={Boolean(formErrors.HamaliAmt)}
                                                    helperText={formErrors.HamaliAmt || ''}
                                                    size="small"
                                                    inputProps={{
                                                        sx: { textAlign: 'right' },
                                                        inputMode: 'decimal',
                                                        pattern: '[0-9]*[.,]?[0-9]+',
                                                        onInput: validateNumericInput,
                                                    }}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            fontSize: '16px',
                                                            fontWeight: 'bold',
                                                            color: 'black',
                                                            backgroundColor: 'white',
                                                            opacity: 1,
                                                            '& .Mui-disabled': {
                                                                color: 'black',
                                                                WebkitTextFillColor: 'black',
                                                                opacity: 1,
                                                            },
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>


                                        <Grid container spacing={1} justifyContent="flex-end" alignItems="center" style={{ marginTop: '-6px' }}>
                                            <Grid item xs={1}>
                                                <label className="SugarSaleBillLabel">Tolai :</label>
                                            </Grid>
                                            <Grid item xs={12} sm={2}>
                                                <TextField
                                                    variant="outlined"
                                                    fullWidth
                                                    name="TolaiAmt"
                                                    autoComplete="off"
                                                    value={formData.TolaiAmt}
                                                    onKeyDown={handleKeyDownCalculations}
                                                    onChange={handleChange}
                                                    disabled
                                                    error={Boolean(formErrors.TolaiAmt)}
                                                    helperText={formErrors.TolaiAmt || ''}
                                                    size="small"
                                                    inputProps={{
                                                        sx: { textAlign: 'right' },
                                                        inputMode: 'decimal',
                                                        pattern: '[0-9]*[.,]?[0-9]+',
                                                        onInput: validateNumericInput,
                                                    }}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            fontSize: '16px',
                                                            fontWeight: 'bold',
                                                            color: 'black',
                                                            backgroundColor: 'white',
                                                            opacity: 1,
                                                            '& .Mui-disabled': {
                                                                color: 'black',
                                                                WebkitTextFillColor: 'black',
                                                                opacity: 1,
                                                            },
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={1} justifyContent="flex-end" alignItems="center" style={{ marginTop: '-6px' }}>
                                            <Grid item xs={1}>
                                                <label className="SugarSaleBillLabel">Market Cess:</label>
                                            </Grid>
                                            <Grid item xs={12} sm={2}>
                                                <TextField
                                                    variant="outlined"
                                                    fullWidth
                                                    name="MarketCess"
                                                    autoComplete="off"
                                                    value={formData.MarketCess}
                                                    onKeyDown={handleKeyDownCalculations}
                                                    onChange={handleChange}
                                                    disabled
                                                    error={Boolean(formErrors.MarketCess)}
                                                    helperText={formErrors.MarketCess || ''}
                                                    size="small"
                                                    inputProps={{
                                                        sx: { textAlign: 'right' },
                                                        inputMode: 'decimal',
                                                        pattern: '[0-9]*[.,]?[0-9]+',
                                                        onInput: validateNumericInput,
                                                    }}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            fontSize: '16px',
                                                            fontWeight: 'bold',
                                                            color: 'black',
                                                            backgroundColor: 'white',
                                                            opacity: 1,
                                                            '& .Mui-disabled': {
                                                                color: 'black',
                                                                WebkitTextFillColor: 'black',
                                                                opacity: 1,
                                                            },
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>



                                        <Grid container spacing={1} justifyContent="flex-end" alignItems="center" style={{ marginTop: '-6px' }}>
                                            <Grid item xs={1}>
                                                <label className="SugarSaleBillLabel">Bill Amount :</label>
                                            </Grid>
                                            <Grid item xs={12} sm={2}>
                                                <TextField
                                                    variant="outlined"
                                                    fullWidth
                                                    name="Bill_Amount"
                                                    value={formData.Bill_Amount}
                                                    onChange={handleChange}
                                                    disabled
                                                    error={Boolean(formErrors.Bill_Amount)}
                                                    helperText={formErrors.Bill_Amount || ''}
                                                    size="small"
                                                    inputProps={{
                                                        sx: { textAlign: 'right' },
                                                        inputMode: 'decimal',
                                                        pattern: '[0-9]*[.,]?[0-9]+',
                                                        onInput: validateNumericInput,
                                                    }}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            fontSize: '16px',
                                                            fontWeight: 'bold',
                                                            color: 'black',
                                                            backgroundColor: 'white',
                                                            opacity: 1,
                                                            '& .Mui-disabled': {
                                                                color: 'black',
                                                                WebkitTextFillColor: 'black',
                                                                opacity: 1,
                                                            },
                                                        },
                                                    }}
                                                />
                                            </Grid>

                                            <Grid container spacing={1} justifyContent="flex-end" alignItems="center" style={{ marginTop: '-6px' }} mb={8} >
                                                <Grid item xs={1}>
                                                    <label className="SugarSaleBillLabel">TDS :</label>
                                                </Grid>
                                                <Grid item xs={12} sm={1}>
                                                    <TextField
                                                        variant="outlined"
                                                        fullWidth
                                                        name="TDS_Rate"
                                                        autoComplete="off"
                                                        value={formData.TDS_Rate}
                                                        onChange={handleChange}
                                                        onKeyDown={handleKeyDownCalculations}
                                                        disabled={!isEditing && addOneButtonEnabled}
                                                        error={Boolean(formErrors.TDS_Rate)}
                                                        helperText={formErrors.TDS_Rate || ''}
                                                        size="small"
                                                        inputProps={{
                                                            sx: { textAlign: 'right' },
                                                            inputMode: 'decimal',
                                                            pattern: '[0-9]*[.,]?[0-9]+',
                                                            onInput: validateNumericInput,
                                                        }}
                                                        sx={{
                                                            '& .MuiOutlinedInput-root': {
                                                                fontSize: '16px',
                                                                fontWeight: 'bold',
                                                                color: 'black',
                                                                backgroundColor: 'white',
                                                                opacity: 1,
                                                                '& .Mui-disabled': {
                                                                    color: 'black',
                                                                    WebkitTextFillColor: 'black',
                                                                    opacity: 1,
                                                                },
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={1} >
                                                    <TextField
                                                        variant="outlined"
                                                        fullWidth
                                                        name="TDS_Amt"
                                                        autoComplete="off"
                                                        value={formData.TDS_Amt}
                                                        onChange={handleChange}
                                                        onKeyDown={handleKeyDownCalculations}
                                                        disabled={!isEditing && addOneButtonEnabled}
                                                        error={Boolean(formErrors.TDS_Amt)}
                                                        helperText={formErrors.TDS_Amt || ''}
                                                        size="small"
                                                        inputProps={{
                                                            sx: { textAlign: 'right' },
                                                            inputMode: 'decimal',
                                                            pattern: '[0-9]*[.,]?[0-9]+',
                                                            onInput: validateNumericInput,
                                                        }}
                                                        sx={{
                                                            '& .MuiOutlinedInput-root': {
                                                                fontSize: '16px',
                                                                fontWeight: 'bold',
                                                                color: 'black',
                                                                backgroundColor: 'white',
                                                                opacity: 1,
                                                                '& .Mui-disabled': {
                                                                    color: 'black',
                                                                    WebkitTextFillColor: 'black',
                                                                    opacity: 1,
                                                                },
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>

                                        </Grid>
                                    </Grid>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form >
        </>
    );
};
export default HaladSaleBill;